import { APPROVED, ASSIGNMENT_STARTED, CREATED, DRAFT, FORCED_UPDATE, IN_REVIEW, NOT_ASKING_TO_REVIEW, READY_TO_ASSIGN, READY_TO_REVIEW, REFUSED, REJECTED, RESET_REVIEW, REVIEWING, VALIDATED, WILL_NOT_REVIEW } from "@overbookd/festival-event-constants";
import { BARRIERES, BDE, COMMUNICATION, CONDUCTEUR, CONFIANCE, HARD, HUMAIN, KARNA, KFET, LOG_ELEC, LOG_MATOS, PERSONNE, SECU, SIGNA, SOFT, TEAM_BOUFFE, TEAM_ELEC, TEAM_MONTAGE, TECKOS, VIEUX } from "@overbookd/team-code";
import { hasAtLeastOneItem, isEmpty, numberGenerator, updateItemToList } from "@overbookd/list";
import { SlugifyService } from "@overbookd/slugify";
import { Duration, ONE_MINUTE_IN_MS, OverDate, Period } from "@overbookd/time";
//#region src/common/inquiry-request.ts
const MAGASIN = "Magasin";
const LIVRE_PAR_LOGISTIQUE = "Livré par l'équipe logistique";
const LIVRE_PAR_TEAM_ELEC = "Livré par l'équipe élec";
const LIVRE_PAR_BAR = "Livré par l'équipe bar";
const LIVRE_PAR_COM = "Livré par une com";
const BENNE_COLLETTE_BESSON = "Benne Collette Besson";
const BENNE_PARKING_K_FET = "Benne Parking K-fet";
const PARKING_EIFFEL = "Parking Eiffel";
const CREUX_GCU = "Creux GCU";
const CREUX_GM = "Creux GM";
const CAVE_E = "Cave E";
const CAVE_BIKERS = "Cave des Bikers";
const CLUB_ROCK = "Club Rock";
const CONTENUR_24H = "Conteneur 24h";
const CONTENEUR_KARNA = "Conteneur Karna";
const CONTENEUR_PARKING_K_FET = "Conteneur Parking K-fet";
const CONTENEUR_SCENE_PULSE = "Conteneur Scène Pulse";
const HALL_DES_HUMANITES = "Hall des Humanités";
const LOCAL_24H = "Local 24h";
const MDE = "MdE";
const SALLE_MONTREAL = "Salle Montréal";
const SALLE_RENE_CHAR = "Salle René Char";
const NON_STOCKE = "Non stocké";
const QG_ORGA = "QG Orga";
const BACKLINE = "Backline";
const SALLE_CRLA = "Salle CRL-A Humanités";
const SALLE_CRLB = "Salle CRL-B Humanités";
const drives = [
	MAGASIN,
	LIVRE_PAR_LOGISTIQUE,
	LIVRE_PAR_TEAM_ELEC,
	LIVRE_PAR_BAR,
	LIVRE_PAR_COM,
	BENNE_COLLETTE_BESSON,
	BENNE_PARKING_K_FET,
	PARKING_EIFFEL,
	CREUX_GCU,
	CREUX_GM,
	CAVE_E,
	CAVE_BIKERS,
	CLUB_ROCK,
	CONTENUR_24H,
	CONTENEUR_KARNA,
	CONTENEUR_PARKING_K_FET,
	CONTENEUR_SCENE_PULSE,
	HALL_DES_HUMANITES,
	LOCAL_24H,
	"MdE",
	SALLE_MONTREAL,
	SALLE_RENE_CHAR,
	NON_STOCKE,
	QG_ORGA,
	BACKLINE,
	SALLE_CRLA,
	SALLE_CRLB
];
function isAssignedToDrive(request) {
	return Object.hasOwn(request, "drive");
}
//#endregion
//#region src/common/review.ts
function isRefusedReviews(reviews) {
	return Object.values(reviews).some((review) => review === REJECTED);
}
function isValidatedReviews(reviews) {
	return Object.values(reviews).every((review) => review === APPROVED || review === NOT_ASKING_TO_REVIEW || review === WILL_NOT_REVIEW);
}
function getNameFromReviewer(team) {
	switch (team) {
		case HUMAIN: return "Humain·e";
		case SIGNA: return "Signa";
		case SECU: return "Sécu";
		case LOG_MATOS: return "Matos";
		case LOG_ELEC: return "Élec";
		case BARRIERES: return "Barrières";
		case COMMUNICATION: return "Communication";
	}
}
//#endregion
//#region src/festival-event.ts
var FestivalEventError = class extends Error {};
function isDraft(event) {
	return event.status === DRAFT;
}
function isInReview(event) {
	return event.status === IN_REVIEW;
}
function isRefused(event) {
	return event.status === REFUSED;
}
function isValidated(event) {
	return event.status === VALIDATED;
}
//#endregion
//#region src/festival-activity/festival-activity.error.ts
function buildFestivalActivityNotFoundErrorMessage(id) {
	return `La fiche activité #${id} n'a pas été trouvée`;
}
const FREE_PASS_MUST_BE_POSITIVE_ERROR_MESSAGE = "Le nombre de laissez passer doit être supérieur ou égale à 0";
const TIME_WINDOW_ALREADY_EXISTS_ERROR_MESSAGE = "Une créneau existe déjà à ces heures";
const CONTRACTOR_NOT_FOUND_ERROR_MESSAGE = "Ce prestataire n'existe pas dans la fiche activité";
const SIGNAGE_NOT_FOUND_ERROR_MESSAGE = "Cette signalétique n'existe pas dans la fiche activité";
const SIGNAGE_ALREADY_EXISTS_ERROR_MESSAGE = "Une signalétique similaire existe déjà dans la fiche activité";
const ELECTRICITY_SUPPLY_NOT_FOUND_ERROR_MESSAGE = "Cette demande d'elec n'existe pas dans la fiche activité";
const ELECTRICITY_SUPPLY_ALREADY_EXISTS_ERROR_MESSAGE = "Une demande d'elec similaire existe déjà dans la fiche activité";
var FestivalActivityError = class extends FestivalEventError {};
var FestivalActivityNotFound = class extends FestivalActivityError {
	constructor(id) {
		super(buildFestivalActivityNotFoundErrorMessage(id));
	}
};
var TimeWindowAlreadyExists = class extends FestivalActivityError {
	constructor() {
		super(TIME_WINDOW_ALREADY_EXISTS_ERROR_MESSAGE);
	}
};
var FreePassMustBePositive = class extends FestivalActivityError {
	constructor() {
		super(FREE_PASS_MUST_BE_POSITIVE_ERROR_MESSAGE);
	}
};
var ContractorNotFound = class extends FestivalActivityError {
	constructor() {
		super(CONTRACTOR_NOT_FOUND_ERROR_MESSAGE);
	}
};
var SignageNotFound = class extends FestivalActivityError {
	constructor() {
		super(SIGNAGE_NOT_FOUND_ERROR_MESSAGE);
	}
};
var SignageAlreadyExists = class extends FestivalActivityError {
	constructor() {
		super(SIGNAGE_ALREADY_EXISTS_ERROR_MESSAGE);
	}
};
var ElectricitySupplyNotFound = class extends FestivalActivityError {
	constructor() {
		super(ELECTRICITY_SUPPLY_NOT_FOUND_ERROR_MESSAGE);
	}
};
var ElectricitySupplyAlreadyExists = class extends FestivalActivityError {
	constructor() {
		super(ELECTRICITY_SUPPLY_ALREADY_EXISTS_ERROR_MESSAGE);
	}
};
//#endregion
//#region src/festival-activity/preview-of.ts
function previewOf(festivalActivity) {
	return PREVIEW_FOR$1[festivalActivity.status](festivalActivity);
}
const PREVIEW_FOR$1 = {
	IN_REVIEW: inReviewPreviewOf$1,
	DRAFT: draftPreviewOf$1,
	VALIDATED: validatedPreviewOf$1,
	REFUSED: refusedPreviewOf$1
};
function draftPreviewOf$1(draft) {
	const supply = draft.supply;
	return {
		id: draft.id,
		name: draft.general.name,
		status: draft.status,
		adherent: draft.inCharge.adherent,
		team: draft.inCharge.team,
		needSupply: supply.electricity.length > 0 || !!supply.water
	};
}
function inReviewPreviewOf$1(inReview) {
	const supply = inReview.supply;
	return {
		id: inReview.id,
		name: inReview.general.name,
		status: inReview.status,
		adherent: inReview.inCharge.adherent,
		team: inReview.inCharge.team,
		needSupply: supply.electricity.length > 0 || !!supply.water,
		reviews: inReview.reviews
	};
}
function validatedPreviewOf$1(validated) {
	const supply = validated.supply;
	return {
		id: validated.id,
		name: validated.general.name,
		status: validated.status,
		adherent: validated.inCharge.adherent,
		team: validated.inCharge.team,
		needSupply: supply.electricity.length > 0 || !!supply.water,
		reviews: validated.reviews
	};
}
function refusedPreviewOf$1(refused) {
	const supply = refused.supply;
	return {
		id: refused.id,
		name: refused.general.name,
		status: refused.status,
		adherent: refused.inCharge.adherent,
		team: refused.inCharge.team,
		needSupply: supply.electricity.length > 0 || !!supply.water,
		reviews: refused.reviews
	};
}
//#endregion
//#region src/festival-activity/sections/supply.ts
const PC16_Prise_classique = "PC16_Prise_classique";
const P17_16A_MONO = "P17_16A_MONO";
const P17_16A_TRI = "P17_16A_TRI";
const P17_16A_TETRA = "P17_16A_TETRA";
const P17_32A_MONO = "P17_32A_MONO";
const P17_32A_TRI = "P17_32A_TRI";
const P17_32A_TETRA = "P17_32A_TETRA";
const P17_63A_MONO = "P17_63A_MONO";
const P17_63A_TRI = "P17_63A_TRI";
const P17_63A_TETRA = "P17_63A_TETRA";
const P17_125A_TETRA = "P17_125A_TETRA";
//#endregion
//#region src/festival-activity/sections/signa.ts
const BACHE = "BACHE";
const PANNEAU = "PANNEAU";
const AFFICHE = "AFFICHE";
const signageTypes = {
	BACHE,
	PANNEAU,
	AFFICHE
};
function isLinkedToCatalogItem(request) {
	return Object.hasOwn(request, "catalogItem");
}
//#endregion
//#region src/festival-activity/festival-activity.event.ts
var FestivalActivityKeyEvents = class {
	static created(by) {
		const at = this.computeAt();
		return {
			action: CREATED,
			by,
			at,
			description: "FA créée"
		};
	}
	static readyToReview(by) {
		const at = this.computeAt();
		return {
			action: READY_TO_REVIEW,
			by,
			at,
			description: "Demande de relecture de la FA"
		};
	}
	static approved(by, team) {
		const at = this.computeAt();
		const description = `FA approuvée par l'équipe ${getNameFromReviewer(team)}`;
		return {
			action: APPROVED,
			by,
			at,
			description
		};
	}
	static rejected(by, team, reason) {
		const at = this.computeAt();
		const description = `FA rejetée par l'équipe ${getNameFromReviewer(team)} pour la raison suivante: ${reason}`;
		return {
			action: REJECTED,
			by,
			at,
			description
		};
	}
	static computeAt() {
		const at = /* @__PURE__ */ new Date();
		at.setMilliseconds(0);
		return at;
	}
};
//#endregion
//#region src/festival-activity/creation/creation.ts
var CreateFestivalActivity = class {
	festivalActivities;
	idGenerator;
	constructor(festivalActivities, startId = 1) {
		this.festivalActivities = festivalActivities;
		this.idGenerator = numberGenerator(startId);
	}
	async create({ name, author }) {
		const activity = {
			id: this.generateId(),
			status: DRAFT,
			general: this.generateGeneralSection(name),
			inCharge: this.generateInChargeSection(author),
			signa: this.generateSignaSection(),
			security: this.generateSecuritySection(),
			supply: this.generateSupplySection(),
			inquiry: this.generateInquirySection(),
			feedbacks: [],
			history: [FestivalActivityKeyEvents.created(author)],
			tasks: []
		};
		return this.festivalActivities.create(activity);
	}
	generateId() {
		return this.idGenerator.next().value;
	}
	generateGeneralSection(name) {
		return {
			name,
			categories: [],
			description: null,
			toPublish: false,
			isFlagship: false,
			photoLink: null,
			timeWindows: []
		};
	}
	generateInChargeSection(author) {
		return {
			adherent: author,
			team: null,
			contractors: []
		};
	}
	generateSignaSection() {
		return {
			location: null,
			signages: []
		};
	}
	generateSecuritySection() {
		return {
			specialNeed: null,
			freePass: 0
		};
	}
	generateSupplySection() {
		return {
			electricity: [],
			water: null
		};
	}
	generateInquirySection() {
		return {
			timeWindows: [],
			gears: [],
			electricity: [],
			barriers: []
		};
	}
};
//#endregion
//#region src/festival-activity/creation/festival-activities.inmemory.ts
var InMemoryCreateFestivalActivityRepository = class {
	festivalActivities;
	constructor(festivalActivities = []) {
		this.festivalActivities = festivalActivities;
	}
	create(activity) {
		this.festivalActivities = [...this.festivalActivities, activity];
		return Promise.resolve(activity);
	}
};
//#endregion
//#region src/festival-activity/festival-activity.fake.ts
const lea = {
	id: 2,
	lastName: "Mouyno",
	firstName: "Lea"
};
//#endregion
//#region src/festival-activity/festival-activity.factory.ts
function defaultDraft(id, name) {
	return {
		id,
		general: {
			name,
			description: null,
			categories: [],
			toPublish: false,
			photoLink: null,
			isFlagship: false,
			timeWindows: []
		},
		status: DRAFT,
		inCharge: {
			adherent: lea,
			team: null,
			contractors: []
		},
		signa: {
			location: null,
			signages: []
		},
		security: {
			specialNeed: null,
			freePass: 0
		},
		supply: {
			electricity: [],
			water: null
		},
		inquiry: {
			timeWindows: [],
			gears: [],
			electricity: [],
			barriers: []
		},
		feedbacks: [],
		history: [FestivalActivityKeyEvents.created(lea)],
		tasks: []
	};
}
//#endregion
//#region src/festival-activity/preparation/section-aggregates/electricity-supplies.ts
var ElectricitySupplies = class ElectricitySupplies {
	electricitySupplies;
	constructor(electricitySupplies) {
		this.electricitySupplies = electricitySupplies;
	}
	get entries() {
		return this.electricitySupplies;
	}
	static build(supplies) {
		return new ElectricitySupplies(supplies);
	}
	add(form) {
		const id = this.generateElectricitySupplyId(form.device, form.connection);
		const comment = form.comment ?? null;
		const supply = {
			...form,
			id,
			comment
		};
		this.throwIfAlreadyExists(id);
		return new ElectricitySupplies([...this.electricitySupplies, supply]);
	}
	update(form) {
		const currentSupplyIndex = this.electricitySupplies.findIndex((es) => es.id === form.id);
		const currentSupply = this.electricitySupplies.at(currentSupplyIndex);
		if (currentSupplyIndex === -1 || !currentSupply) throw new ElectricitySupplyNotFound();
		const updatedSupply = this.generateUpdatedSupply(currentSupply, form);
		if (currentSupply.id !== updatedSupply.id) this.throwIfAlreadyExists(updatedSupply.id);
		const electricitySupplies = updateItemToList(this.electricitySupplies, currentSupplyIndex, updatedSupply);
		return new ElectricitySupplies(electricitySupplies);
	}
	remove(id) {
		return new ElectricitySupplies(this.electricitySupplies.filter((es) => es.id !== id));
	}
	generateElectricitySupplyId(device, connection) {
		return SlugifyService.apply(`${device} ${connection}`);
	}
	throwIfAlreadyExists(id) {
		if (this.electricitySupplies.some((es) => es.id === id)) throw new ElectricitySupplyAlreadyExists();
	}
	generateUpdatedSupply(previousSupply, form) {
		const updatedSupply = {
			...previousSupply,
			connection: form.connection ?? previousSupply.connection,
			device: form.device ?? previousSupply.device,
			power: form.power ?? previousSupply.power,
			count: form.count ?? previousSupply.count,
			comment: form.comment === void 0 ? previousSupply.comment : form.comment
		};
		const id = this.generateElectricitySupplyId(updatedSupply.device, updatedSupply.connection);
		return {
			...updatedSupply,
			id
		};
	}
};
//#endregion
//#region src/festival-activity/preparation/section-aggregates/contractors.ts
var Contractors = class Contractors {
	contractors;
	constructor(contractors) {
		this.contractors = contractors;
	}
	get entries() {
		return this.contractors;
	}
	static build(contractors) {
		return new Contractors(contractors);
	}
	add(form) {
		const id = this.generateContractorId();
		const contractor = {
			...form,
			id,
			email: form.email ?? null,
			company: form.company ?? null,
			comment: form.comment ?? null
		};
		return new Contractors([...this.contractors, contractor]);
	}
	update(contractor) {
		const currentContractorIndex = this.contractors.findIndex((c) => c.id === contractor.id);
		const currentContractor = this.contractors.at(currentContractorIndex);
		if (currentContractorIndex === -1 || !currentContractor) throw new ContractorNotFound();
		const updatedContractor = this.generateUpdatedContractor(currentContractor, contractor);
		const contractors = updateItemToList(this.contractors, currentContractorIndex, updatedContractor);
		return new Contractors(contractors);
	}
	remove(id) {
		return new Contractors(this.contractors.filter((c) => c.id !== id));
	}
	generateContractorId() {
		return (this.contractors.at(-1)?.id ?? 0) + 1;
	}
	generateUpdatedContractor(previousContractor, form) {
		return {
			...previousContractor,
			firstName: form.firstName ?? previousContractor.firstName,
			lastName: form.lastName ?? previousContractor.lastName,
			phoneNumber: form.phoneNumber ?? previousContractor.phoneNumber,
			email: form.email === void 0 ? previousContractor.email : form.email,
			company: form.company === void 0 ? previousContractor.company : form.company,
			comment: form.comment === void 0 ? previousContractor.comment : form.comment
		};
	}
};
//#endregion
//#region src/festival-activity/preparation/section-aggregates/time-windows.ts
var TimeWindows = class TimeWindows {
	timeWindows;
	constructor(timeWindows) {
		this.timeWindows = timeWindows;
	}
	get entries() {
		return this.timeWindows;
	}
	static build(timeWindows) {
		return new TimeWindows(timeWindows);
	}
	add(period) {
		const { id, start, end } = Period.init(period);
		const timeWindow = {
			id,
			start,
			end
		};
		if (this.timeWindows.some((tw) => tw.id === id)) throw new TimeWindowAlreadyExists();
		return new TimeWindows([timeWindow, ...this.timeWindows]);
	}
	update(currentId, period) {
		if (!this.timeWindows.some((tw) => tw.id === currentId)) throw new PrepareError.TimeWindowNotFound();
		const { id, start, end } = Period.init(period);
		const timeWindow = {
			id,
			start,
			end
		};
		const timeWindows = this.timeWindows.map((tw) => tw.id === currentId ? timeWindow : tw);
		return new TimeWindows(timeWindows);
	}
	remove(id) {
		return new TimeWindows(this.timeWindows.filter((tw) => tw.id !== id));
	}
};
//#endregion
//#region src/festival-task/festival-task.error.ts
var FestivalTaskError = class extends FestivalEventError {};
var FestivalTaskNotFound = class extends FestivalTaskError {
	constructor(ftId) {
		const message = `La fiche tâche #${ftId} n'a pas été trouvée`;
		super(message);
	}
};
var CannotIgnoreFestivalTask = class extends FestivalTaskError {
	constructor() {
		super("Tu ne peux pas ignorer une fiche tâche");
	}
};
var CannotIgnoreFestivalTaskWithInquiryRequests = class extends FestivalTaskError {
	constructor() {
		super("La log matos ne peux pas ignorer une fiche tâche ayant des demandes de matos");
	}
};
var SplitDurationIsNotPeriodDivider = class extends FestivalTaskError {
	constructor(duration) {
		const message = `La période n'est pas divisible en ${duration.inHours} heures`;
		super(message);
	}
};
var MobilizationAlreadyExist = class extends FestivalTaskError {
	constructor() {
		super("Un autre créneau existe sur cette même période");
	}
};
var MobilizationNotFound = class extends FestivalTaskError {
	constructor() {
		super("Il n'y a pas de mobilisation correspondante");
	}
};
var FestivalTaskNotValidated = class extends FestivalTaskError {
	constructor(ftId) {
		super(`La fiche tâche #${ftId} n'est pas encore validée`);
	}
};
const CANT_START_ASSIGNMENT_ERROR_MESSAGE = "Impossible de démarrer l'affectation pour cette FT.";
const AT_LEAST_ONE_VOLUNTEER_IS_NOT_AVAILABLE = "Au moins un des bénévoles n'est pas disponible.";
var ReadyToAssignError = class extends FestivalTaskError {
	constructor() {
		super(`${CANT_START_ASSIGNMENT_ERROR_MESSAGE}\n- ${AT_LEAST_ONE_VOLUNTEER_IS_NOT_AVAILABLE}`);
	}
};
var ForceUpdateError = class ForceUpdateError extends FestivalTaskError {
	static isDraft(ftId) {
		const isDraft = `La fiche tâche #${ftId} est en brouillon`;
		return new ForceUpdateError(isDraft);
	}
	static noApprovals(ftId) {
		const noApprovals = `La fiche tâche #${ftId} n'a aucune approbation`;
		return new ForceUpdateError(noApprovals);
	}
};
var RemoveReadyToAssignError = class extends FestivalTaskError {
	constructor(ftId) {
		const message = `Impossible de supprimer la fiche tâche #${ftId} car elle est déjà en cours d'affectation`;
		super(message);
	}
};
//#endregion
//#region src/common/inquiry-request.error.ts
var AssignDriveInDraft = class extends FestivalEventError {
	constructor(identifier) {
		super(`Il n'est pas possible d'attribuer un lieu à une demande de matos dans une ${identifier} en brouillon`);
	}
};
var InquiryAlreadyExists = class extends FestivalEventError {
	constructor(gear) {
		super(`Une demande de matos existe déjà pour ${gear}`);
	}
};
var InquiryNotFound = class extends FestivalEventError {
	constructor(gear) {
		super(`Il n'y a aucune demande de matos pour ${gear}`);
	}
};
//#endregion
//#region src/festival-activity/preparation/section-aggregates/inquiries.ts
var AlreadyInitialized = class extends FestivalActivityError {
	constructor() {
		super("La section Demande de matos a déjà été initialisée");
	}
};
var NotYetInitialized = class extends FestivalActivityError {
	constructor() {
		super("La section Demande de matos n'a pas encore été initialisée.");
	}
};
var CantRemoveLastTimeWindow = class extends FestivalActivityError {
	constructor() {
		super("Il s'agit du dernier créneau matos. Il n'est pas possible de le supprimer");
	}
};
var CantRemoveLastRequest = class extends FestivalActivityError {
	constructor() {
		super("Il s'agit de la dernière demande de matos. Il n'est pas possible de la supprimer");
	}
};
var Inquiries$1 = class Inquiries$1 {
	timeWindows;
	gears;
	barriers;
	electricity;
	constructor(timeWindows, gears, barriers, electricity) {
		this.timeWindows = timeWindows;
		this.gears = gears;
		this.barriers = barriers;
		this.electricity = electricity;
	}
	get inquiry() {
		return {
			timeWindows: this.timeWindows.entries,
			gears: this.gears.entries,
			barriers: this.barriers.entries,
			electricity: this.electricity.entries
		};
	}
	static build({ timeWindows, gears, barriers, electricity }) {
		return new Inquiries$1(TimeWindows.build(timeWindows), InquiryRequests.build(gears), InquiryRequests.build(barriers), InquiryRequests.build(electricity));
	}
	static init() {
		return new Inquiries$1(TimeWindows.build([]), InquiryRequests.build([]), InquiryRequests.build([]), InquiryRequests.build([]));
	}
	static alreadyInitialized(inquiry) {
		const hasTimeWindows = inquiry.timeWindows.length > 0;
		const hasRequests = [
			...inquiry.gears,
			...inquiry.barriers,
			...inquiry.electricity
		].length > 0;
		return hasTimeWindows || hasRequests;
	}
	addRequest({ owner, ...request }) {
		switch (owner) {
			case LOG_MATOS: return new Inquiries$1(this.timeWindows, this.gears.add(request), this.barriers, this.electricity);
			case BARRIERES: return new Inquiries$1(this.timeWindows, this.gears, this.barriers.add(request), this.electricity);
			case LOG_ELEC: return new Inquiries$1(this.timeWindows, this.gears, this.barriers, this.electricity.add(request));
		}
	}
	updateRequest({ owner, ...request }) {
		switch (owner) {
			case LOG_MATOS: return new Inquiries$1(this.timeWindows, this.gears.update(request), this.barriers, this.electricity);
			case BARRIERES: return new Inquiries$1(this.timeWindows, this.gears, this.barriers.update(request), this.electricity);
			case LOG_ELEC: return new Inquiries$1(this.timeWindows, this.gears, this.barriers, this.electricity.update(request));
		}
	}
	removeRequest(slug) {
		return new Inquiries$1(this.timeWindows, this.gears.remove(slug), this.barriers.remove(slug), this.electricity.remove(slug));
	}
	addTimeWindow(timeWindow) {
		return new Inquiries$1(this.timeWindows.add(timeWindow), this.gears, this.barriers, this.electricity);
	}
	updateTimeWindow(id, period) {
		return new Inquiries$1(this.timeWindows.update(id, period), this.gears, this.barriers, this.electricity);
	}
	removeTimeWindow(id) {
		return new Inquiries$1(this.timeWindows.remove(id), this.gears, this.barriers, this.electricity);
	}
	assignDrive({ owner, ...assign }) {
		switch (owner) {
			case LOG_MATOS: return new Inquiries$1(this.timeWindows, this.gears.assignDrive(assign), this.barriers, this.electricity);
			case BARRIERES: return new Inquiries$1(this.timeWindows, this.gears, this.barriers.assignDrive(assign), this.electricity);
			case LOG_ELEC: return new Inquiries$1(this.timeWindows, this.gears, this.barriers, this.electricity.assignDrive(assign));
		}
	}
};
var InquiryRequests = class InquiryRequests {
	inquiries;
	constructor(inquiries) {
		this.inquiries = inquiries;
	}
	get entries() {
		return this.inquiries;
	}
	static build(inquiries) {
		return new InquiryRequests(inquiries);
	}
	add(inquiry) {
		if (this.inquiries.some(({ slug }) => slug === inquiry.slug)) throw new InquiryAlreadyExists(inquiry.name);
		return new InquiryRequests([inquiry, ...this.inquiries]);
	}
	update(inquiry) {
		const inquiryIndex = this.inquiries.findIndex(({ slug }) => slug === inquiry.slug);
		if (inquiryIndex === -1) throw new InquiryNotFound(inquiry.name);
		const inquiries = updateItemToList(this.inquiries, inquiryIndex, inquiry);
		return new InquiryRequests(inquiries);
	}
	remove(slug) {
		return new InquiryRequests(this.inquiries.filter((inquiry) => inquiry.slug !== slug));
	}
	assignDrive({ slug, drive }) {
		const inquiryIndex = this.inquiries.findIndex((inquiry) => inquiry.slug === slug);
		const inquiry = this.inquiries.at(inquiryIndex);
		if (inquiryIndex === -1 || !inquiry) throw new FestivalTaskError("Aucune demande de matos ne corresond");
		const inquiries = updateItemToList(this.inquiries, inquiryIndex, {
			...inquiry,
			drive
		});
		return new InquiryRequests(inquiries);
	}
};
//#endregion
//#region src/festival-activity/preparation/section-aggregates/signages.ts
var LocationIsRequired = class extends FestivalActivityError {
	constructor() {
		super("Le lieu ne peut pas être remis à zero");
	}
};
var Signages = class Signages {
	signages;
	constructor(signages) {
		this.signages = signages;
	}
	get entries() {
		return this.signages;
	}
	static build(signages) {
		return new Signages(signages);
	}
	add(form) {
		const id = this.generateSignageId(form.type, form.text, form.size);
		const signage = {
			...form,
			id,
			comment: form.comment ?? null
		};
		this.throwIfAlreadyExists(id);
		return new Signages([...this.signages, signage]);
	}
	update(form) {
		const currentSignageIndex = this.signages.findIndex((signage) => signage.id === form.id);
		const currentSignage = this.signages.at(currentSignageIndex);
		if (currentSignageIndex === -1 || !currentSignage) throw new SignageNotFound();
		const updatedSignage = this.generateUpdatedSignage(currentSignage, form);
		if (updatedSignage.id !== currentSignage.id) this.throwIfAlreadyExists(updatedSignage.id);
		const signages = updateItemToList(this.signages, currentSignageIndex, updatedSignage);
		return new Signages(signages);
	}
	remove(id) {
		return new Signages(this.signages.filter((s) => s.id !== id));
	}
	linkCatalogItem({ signageId, catalogItem }) {
		const signageIndex = this.signages.findIndex((inquiry) => inquiry.id === signageId);
		const signage = this.signages.at(signageIndex);
		if (signageIndex === -1 || !signage) throw new SignageNotFound();
		const signages = updateItemToList(this.signages, signageIndex, {
			...signage,
			catalogItem
		});
		return new Signages(signages);
	}
	generateUpdatedSignage(previousSignage, form) {
		const updatedSignage = {
			...previousSignage,
			text: form.text ?? previousSignage.text,
			quantity: form.quantity ?? previousSignage.quantity,
			size: form.size ?? previousSignage.size,
			type: form.type ?? previousSignage.type,
			comment: form.comment === void 0 ? previousSignage.comment : form.comment
		};
		const id = this.generateSignageId(updatedSignage.type, updatedSignage.text, updatedSignage.size);
		return {
			...updatedSignage,
			id
		};
	}
	generateSignageId(type, text, size) {
		return SlugifyService.apply(`${type} ${text} ${size}`);
	}
	throwIfAlreadyExists(id) {
		if (this.signages.some((signage) => signage.id === id)) throw new SignageAlreadyExists();
	}
};
//#endregion
//#region src/festival-activity/sections/general.ts
function isPrivate(general) {
	return general.toPublish === false;
}
//#endregion
//#region src/common/review.error.ts
var NotAskingToReview = class extends FestivalEventError {
	constructor(eventId, team, identifier) {
		const message = `La ${identifier} #${eventId} n'est pas à valider par l'équipe ${getNameFromReviewer(team)}`;
		super(message);
	}
};
var CantAskForReview = class extends FestivalEventError {
	constructor(eventId, identifier = "FA") {
		super(`La ${identifier === "FA" ? "fiche activité" : "fiche tâche"} #${eventId} n'a pas été passée en demande de relecture. Seules des ${identifier}s refusées ou en brouillon le peuvent`);
	}
};
var ShouldAssignDrive = class extends FestivalEventError {
	constructor(identifier = "FA") {
		super(`Il faut attribuer des lieux de retrait aux demandes de matos avant de valider la ${identifier}`);
	}
};
var AlreadyApproved = class extends FestivalEventError {
	constructor(eventId, team, identifier) {
		const message = `La ${identifier} #${eventId} est validée par l'équipe ${getNameFromReviewer(team)}`;
		super(message);
	}
};
var AlreadyApprovedBy = class extends FestivalEventError {
	constructor(reviewers, identifier) {
		const noun = reviewers.length > 1 ? "les équipes" : "l'équipe";
		const reviewerListing = reviewers.join(" et ");
		super(`La ${identifier} a déjà été validée par ${noun} ${reviewerListing}.`);
	}
};
//#endregion
//#region src/festival-activity/preparation/prepare-in-review-festival-activity.ts
var IsNotPublicActivity = class extends FestivalActivityError {
	constructor(missingParts) {
		super(["Il n'est pas possible de rendre publique cette FA", ...missingParts].join("\n"));
	}
};
var NeedAtLeastOneTimeWindow = class extends FestivalActivityError {
	constructor() {
		super("Il faut garder au moins un créneau.");
	}
};
var TimeWindowNotFound = class extends FestivalActivityError {
	constructor() {
		super("Le créneau n'a pas été trouvé.");
	}
};
const PrepareError = {
	IsNotPublicActivity,
	NeedAtLeastOneTimeWindow,
	AlreadyApprovedBy,
	TimeWindowNotFound
};
var General = class General {
	general;
	constructor(general) {
		this.general = general;
	}
	static init(general) {
		return new General(general);
	}
	isAlreadyValidatedBy(reviewer, reviews) {
		switch (reviewer) {
			case COMMUNICATION: return reviews.communication === APPROVED;
			case HUMAIN: return reviews.humain === APPROVED;
		}
	}
	update(form) {
		const name = form.name ?? this.general.name;
		const description = form.description ?? this.general.description;
		const categories = form.categories ?? this.general.categories;
		const toPublish = form.toPublish ?? this.general.toPublish;
		const isFlagship = form.isFlagship ?? this.general.isFlagship;
		const photoLink = form.photoLink ?? this.general.photoLink;
		const { timeWindows } = this.general;
		if (!toPublish) return {
			...this.general,
			name,
			description,
			toPublish: false,
			categories,
			isFlagship: false,
			photoLink: null
		};
		if (!hasAtLeastOneItem(categories) || !this.hasSetPhotoLink(photoLink) || !hasAtLeastOneItem(timeWindows)) throw new IsNotPublicActivity([
			{
				verify: hasAtLeastOneItem(categories),
				message: "Il faut au moins une catégorie."
			},
			{
				verify: this.hasSetPhotoLink(photoLink),
				message: "Il faut définir un lien pour la photo."
			},
			{
				verify: hasAtLeastOneItem,
				message: "Il faut au moins un créneau."
			}
		].filter(({ verify }) => !verify).map(({ message }) => `- ${message}`));
		return {
			name,
			description,
			toPublish,
			categories,
			isFlagship,
			photoLink,
			timeWindows
		};
	}
	hasSetPhotoLink(photoLink) {
		return photoLink !== null;
	}
};
var PrepareInReviewFestivalActivity = class PrepareInReviewFestivalActivity {
	activity;
	constructor(activity) {
		this.activity = activity;
	}
	static build(activity) {
		return new PrepareInReviewFestivalActivity(activity);
	}
	updateGeneral(form) {
		this.checkIfGeneralAlreadyApproved();
		const general = General.init(this.activity.general).update(form);
		if (!(this.activity.general.toPublish !== general.toPublish)) return {
			...this.activity,
			general
		};
		const reviews = {
			...this.activity.reviews,
			communication: general.toPublish ? REVIEWING : NOT_ASKING_TO_REVIEW
		};
		if (isValidatedReviews(reviews)) return {
			...this.activity,
			general,
			reviews,
			status: VALIDATED
		};
		if (isRefusedReviews(reviews)) return {
			...this.activity,
			general,
			reviews,
			status: REFUSED
		};
		return {
			...this.activity,
			general,
			reviews,
			status: IN_REVIEW
		};
	}
	checkIfGeneralAlreadyApproved(askingReviewer) {
		const { reviews, general: generalData } = this.activity;
		const defaultReviewer = generalData.toPublish ? COMMUNICATION : HUMAIN;
		const reviewer = askingReviewer ?? defaultReviewer;
		if (General.init(generalData).isAlreadyValidatedBy(reviewer, reviews)) throw new AlreadyApprovedBy([reviewer], "FA");
	}
	addGeneralTimeWindow(period) {
		this.checkIfGeneralAlreadyApproved(HUMAIN);
		const timeWindows = TimeWindows.build(this.activity.general.timeWindows).add(period).entries;
		const general = {
			...this.activity.general,
			timeWindows
		};
		return {
			...this.activity,
			general
		};
	}
	updateGeneralTimeWindow(id, period) {
		this.checkIfGeneralAlreadyApproved(HUMAIN);
		const timeWindows = TimeWindows.build(this.activity.general.timeWindows).update(id, period).entries;
		const general = {
			...this.activity.general,
			timeWindows
		};
		return {
			...this.activity,
			general
		};
	}
	removeGeneralTimeWindow(id) {
		this.checkIfGeneralAlreadyApproved(HUMAIN);
		const currentGeneral = this.activity.general;
		const timeWindows = TimeWindows.build(currentGeneral.timeWindows).remove(id).entries;
		if (isPrivate(currentGeneral)) {
			const general = {
				...currentGeneral,
				timeWindows
			};
			return {
				...this.activity,
				general
			};
		}
		if (!hasAtLeastOneItem(timeWindows)) throw new NeedAtLeastOneTimeWindow();
		const general = {
			...currentGeneral,
			timeWindows
		};
		return {
			...this.activity,
			general
		};
	}
	updateInCharge(form) {
		this.checkIfInChargeAlreadyApproved();
		const adherent = form.adherent ?? this.activity.inCharge.adherent;
		const team = form.team ?? this.activity.inCharge.team;
		const inCharge = {
			...this.activity.inCharge,
			adherent,
			team
		};
		return {
			...this.activity,
			inCharge
		};
	}
	checkIfInChargeAlreadyApproved() {
		if (this.activity.reviews.humain === APPROVED) throw new AlreadyApprovedBy([HUMAIN], "FA");
	}
	addContractor(contractor) {
		this.checkIfInChargeAlreadyApproved();
		const contractors = Contractors.build(this.activity.inCharge.contractors).add(contractor).entries;
		const inCharge = {
			...this.activity.inCharge,
			contractors
		};
		return {
			...this.activity,
			inCharge
		};
	}
	updateContractor(contractor) {
		this.checkIfInChargeAlreadyApproved();
		const contractors = Contractors.build(this.activity.inCharge.contractors).update(contractor).entries;
		const inCharge = {
			...this.activity.inCharge,
			contractors
		};
		return {
			...this.activity,
			inCharge
		};
	}
	removeContractor(id) {
		this.checkIfInChargeAlreadyApproved();
		const contractors = Contractors.build(this.activity.inCharge.contractors).remove(id).entries;
		const inCharge = {
			...this.activity.inCharge,
			contractors
		};
		return {
			...this.activity,
			inCharge
		};
	}
	updateSigna({ location }) {
		this.checkIfSignaAlreadyApproved();
		if (location === null) throw new LocationIsRequired();
		const signa = {
			...this.activity.signa,
			location
		};
		return {
			...this.activity,
			signa
		};
	}
	checkIfSignaAlreadyApproved() {
		if (this.activity.reviews.signa === APPROVED) throw new AlreadyApprovedBy([SIGNA], "FA");
	}
	addSignage(signage) {
		this.checkIfSignaAlreadyApproved();
		const signages = Signages.build(this.activity.signa.signages).add(signage).entries;
		const signa = {
			...this.activity.signa,
			signages
		};
		return {
			...this.activity,
			signa
		};
	}
	updateSignage(signage) {
		this.checkIfSignaAlreadyApproved();
		const signages = Signages.build(this.activity.signa.signages).update(signage).entries;
		const signa = {
			...this.activity.signa,
			signages
		};
		return {
			...this.activity,
			signa
		};
	}
	removeSignage(id) {
		this.checkIfSignaAlreadyApproved();
		const signages = Signages.build(this.activity.signa.signages).remove(id).entries;
		const signa = {
			...this.activity.signa,
			signages
		};
		return {
			...this.activity,
			signa
		};
	}
	linkSignageToCatalogItem(link) {
		const signages = Signages.build(this.activity.signa.signages).linkCatalogItem(link).entries;
		const signa = {
			...this.activity.signa,
			signages
		};
		return {
			...this.activity,
			signa
		};
	}
	updateSecurity(form) {
		this.checkIfSecurityAlreadyApproved();
		const specialNeed = form.specialNeed === void 0 ? this.activity.security.specialNeed : form.specialNeed;
		const freePass = form.freePass ?? this.activity.security.freePass;
		if (freePass < 0) throw new FreePassMustBePositive();
		const security = {
			...this.activity.inCharge,
			specialNeed,
			freePass
		};
		return {
			...this.activity,
			security
		};
	}
	checkIfSecurityAlreadyApproved() {
		if (this.activity.reviews.secu === APPROVED) throw new AlreadyApprovedBy([SECU], "FA");
	}
	updateSupply(form) {
		this.checkIfSupplyAlreadyApproved();
		const supply = {
			...this.activity.supply,
			...form
		};
		return {
			...this.activity,
			supply
		};
	}
	checkIfSupplyAlreadyApproved() {
		if (this.activity.reviews.elec === APPROVED) throw new AlreadyApprovedBy([LOG_ELEC], "FA");
	}
	addElectricitySupply(electricitySupply) {
		this.checkIfSupplyAlreadyApproved();
		const electricity = ElectricitySupplies.build(this.activity.supply.electricity).add(electricitySupply).entries;
		const supply = {
			...this.activity.supply,
			electricity
		};
		return {
			...this.activity,
			supply
		};
	}
	updateElectricitySupply(electricitySupply) {
		this.checkIfSupplyAlreadyApproved();
		const electricity = ElectricitySupplies.build(this.activity.supply.electricity).update(electricitySupply).entries;
		const supply = {
			...this.activity.supply,
			electricity
		};
		return {
			...this.activity,
			supply
		};
	}
	removeElectricitySupply(id) {
		this.checkIfSupplyAlreadyApproved();
		const electricity = ElectricitySupplies.build(this.activity.supply.electricity).remove(id).entries;
		const supply = {
			...this.activity.supply,
			electricity
		};
		return {
			...this.activity,
			supply
		};
	}
	initInquiry({ request, timeWindow }) {
		if (Inquiries$1.alreadyInitialized(this.activity.inquiry)) throw new AlreadyInitialized();
		this.checkIfInquiryAlreadyApprovedBy(request.owner);
		const inquiry = Inquiries$1.init().addRequest(request).addTimeWindow(timeWindow).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	clearInquiry() {
		this.checkIfHasImpactOnApprovedRequests();
		const inquiry = Inquiries$1.init().inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	addInquiryTimeWindow(period) {
		this.checkIfHasImpactOnApprovedRequests();
		this.checkIfAlreadyInitialized();
		const inquiry = Inquiries$1.build(this.activity.inquiry).addTimeWindow(period).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	updateInquiryTimeWindow(id, period) {
		this.checkIfHasImpactOnApprovedRequests();
		this.checkIfAlreadyInitialized();
		const inquiry = Inquiries$1.build(this.activity.inquiry).updateTimeWindow(id, period).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	checkIfHasImpactOnApprovedRequests() {
		const hasImpact = [
			[this.activity.inquiry.electricity, LOG_ELEC],
			[this.activity.inquiry.gears, LOG_MATOS],
			[this.activity.inquiry.barriers, BARRIERES]
		].some(([request, owner]) => {
			const hasRequest = request.length > 0;
			const { approved } = this.isInquiryApprovedBy(owner);
			return hasRequest && approved;
		});
		const allApproved = this.activity.reviews.barrieres === APPROVED && this.activity.reviews.elec === APPROVED && this.activity.reviews.matos === APPROVED;
		if (hasImpact || allApproved) return this.checkIfInquiryAlreadyApprovedBy();
	}
	checkIfInquiryAlreadyApprovedBy(owner) {
		const { approved, teams } = this.isInquiryApprovedBy(owner);
		if (approved) throw new AlreadyApprovedBy(teams, "FA");
	}
	isInquiryApprovedBy(owner) {
		const hasElecApproved = {
			approved: this.activity.reviews.elec === APPROVED,
			teams: [LOG_ELEC]
		};
		const hasMatosApproved = {
			approved: this.activity.reviews.matos === APPROVED,
			teams: [LOG_MATOS]
		};
		const hasBarrierersApproved = {
			approved: this.activity.reviews.barrieres === APPROVED,
			teams: [BARRIERES]
		};
		const reviews = [
			hasBarrierersApproved,
			hasElecApproved,
			hasMatosApproved
		];
		switch (owner) {
			case void 0: return reviews.reduce((acc, approval) => {
				return {
					approved: acc.approved || approval.approved,
					teams: approval.approved ? [...acc.teams, ...approval.teams] : acc.teams
				};
			}, {
				approved: false,
				teams: []
			});
			case LOG_MATOS: return hasMatosApproved;
			case LOG_ELEC: return hasElecApproved;
			case BARRIERES: return hasBarrierersApproved;
		}
	}
	removeInquiryTimeWindow(id) {
		this.checkIfHasImpactOnApprovedRequests();
		const inquiry = Inquiries$1.build(this.activity.inquiry).removeTimeWindow(id).inquiry;
		if (this.hasNoTimeWindowRemaining(inquiry)) throw new CantRemoveLastTimeWindow();
		return {
			...this.activity,
			inquiry
		};
	}
	hasNoTimeWindowRemaining(inquiry) {
		return inquiry.timeWindows.length === 0;
	}
	addInquiry(request) {
		this.checkIfInquiryAlreadyApprovedBy(request.owner);
		this.checkIfAlreadyInitialized();
		const inquiry = Inquiries$1.build(this.activity.inquiry).addRequest(request).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	checkIfAlreadyInitialized() {
		if (!Inquiries$1.alreadyInitialized(this.activity.inquiry)) throw new NotYetInitialized();
	}
	updateInquiry(request) {
		this.checkIfInquiryAlreadyApprovedBy(request.owner);
		const inquiry = Inquiries$1.build(this.activity.inquiry).updateRequest(request).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	removeInquiry(request) {
		this.checkIfInquiryAlreadyApprovedBy(request.owner);
		const inquiry = Inquiries$1.build(this.activity.inquiry).removeRequest(request.slug).inquiry;
		if (this.hasNoRequestRemaining(inquiry)) throw new CantRemoveLastRequest();
		return {
			...this.activity,
			inquiry
		};
	}
	hasNoRequestRemaining(inquiry) {
		return [
			...inquiry.gears,
			...inquiry.barriers,
			...inquiry.electricity
		].length === 0;
	}
	assignInquiryToDrive(link) {
		const inquiry = Inquiries$1.build(this.activity.inquiry).assignDrive(link).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
};
//#endregion
//#region src/festival-activity/preparation/prepare-draft-festival-activity.ts
var AssignCatalogItemInDraftActivity = class extends FestivalActivityError {
	constructor() {
		super("Il n'est pas possible d'attribuer une signalétique du catalogue à une demande de signalétique dans une FA en brouillon");
	}
};
var PrepareDraftFestivalActivity = class PrepareDraftFestivalActivity {
	activity;
	constructor(activity) {
		this.activity = activity;
	}
	static build(activity) {
		return new PrepareDraftFestivalActivity(activity);
	}
	updateGeneral(form) {
		const privateFestivalActivity = {
			toPublish: false,
			photoLink: null,
			isFlagship: false
		};
		const cleanedUpdate = form.toPublish === false ? {
			...form,
			...privateFestivalActivity
		} : form;
		const general = {
			...this.activity.general,
			...cleanedUpdate
		};
		return {
			...this.activity,
			general
		};
	}
	addGeneralTimeWindow(period) {
		const timeWindows = TimeWindows.build(this.activity.general.timeWindows).add(period).entries;
		const general = {
			...this.activity.general,
			timeWindows
		};
		return {
			...this.activity,
			general
		};
	}
	updateGeneralTimeWindow(id, period) {
		const timeWindows = TimeWindows.build(this.activity.general.timeWindows).update(id, period).entries;
		const general = {
			...this.activity.general,
			timeWindows
		};
		return {
			...this.activity,
			general
		};
	}
	removeGeneralTimeWindow(id) {
		const timeWindows = TimeWindows.build(this.activity.general.timeWindows).remove(id).entries;
		const general = {
			...this.activity.general,
			timeWindows
		};
		return {
			...this.activity,
			general
		};
	}
	updateInCharge(form) {
		const inCharge = {
			...this.activity.inCharge,
			...form
		};
		return {
			...this.activity,
			inCharge
		};
	}
	addContractor(contractor) {
		const contractors = Contractors.build(this.activity.inCharge.contractors).add(contractor).entries;
		const inCharge = {
			...this.activity.inCharge,
			contractors
		};
		return {
			...this.activity,
			inCharge
		};
	}
	updateContractor(contractor) {
		const contractors = Contractors.build(this.activity.inCharge.contractors).update(contractor).entries;
		const inCharge = {
			...this.activity.inCharge,
			contractors
		};
		return {
			...this.activity,
			inCharge
		};
	}
	removeContractor(id) {
		const contractors = Contractors.build(this.activity.inCharge.contractors).remove(id).entries;
		const inCharge = {
			...this.activity.inCharge,
			contractors
		};
		return {
			...this.activity,
			inCharge
		};
	}
	updateSigna(form) {
		const signa = {
			...this.activity.signa,
			...form
		};
		return {
			...this.activity,
			signa
		};
	}
	addSignage(signage) {
		const signages = Signages.build(this.activity.signa.signages).add(signage).entries;
		const signa = {
			...this.activity.signa,
			signages
		};
		return {
			...this.activity,
			signa
		};
	}
	updateSignage(signage) {
		const signages = Signages.build(this.activity.signa.signages).update(signage).entries;
		const signa = {
			...this.activity.signa,
			signages
		};
		return {
			...this.activity,
			signa
		};
	}
	removeSignage(id) {
		const signages = Signages.build(this.activity.signa.signages).remove(id).entries;
		const signa = {
			...this.activity.signa,
			signages
		};
		return {
			...this.activity,
			signa
		};
	}
	linkSignageToCatalogItem() {
		throw new AssignCatalogItemInDraftActivity();
	}
	updateSecurity(form) {
		const security = {
			...this.activity.security,
			...form
		};
		if (security.freePass < 0) throw new FreePassMustBePositive();
		return {
			...this.activity,
			security
		};
	}
	updateSupply(form) {
		const supply = {
			...this.activity.supply,
			...form
		};
		return {
			...this.activity,
			supply
		};
	}
	addElectricitySupply(electricitySupply) {
		const electricity = ElectricitySupplies.build(this.activity.supply.electricity).add(electricitySupply).entries;
		const supply = {
			...this.activity.supply,
			electricity
		};
		return {
			...this.activity,
			supply
		};
	}
	updateElectricitySupply(electricitySupply) {
		const electricity = ElectricitySupplies.build(this.activity.supply.electricity).update(electricitySupply).entries;
		const supply = {
			...this.activity.supply,
			electricity
		};
		return {
			...this.activity,
			supply
		};
	}
	removeElectricitySupply(id) {
		const electricity = ElectricitySupplies.build(this.activity.supply.electricity).remove(id).entries;
		const supply = {
			...this.activity.supply,
			electricity
		};
		return {
			...this.activity,
			supply
		};
	}
	initInquiry({ timeWindow, request }) {
		if (Inquiries$1.alreadyInitialized(this.activity.inquiry)) throw new AlreadyInitialized();
		const inquiry = Inquiries$1.init().addRequest(request).addTimeWindow(timeWindow).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	clearInquiry() {
		const inquiry = Inquiries$1.init().inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	addInquiryTimeWindow(period) {
		const inquiry = Inquiries$1.build(this.activity.inquiry).addTimeWindow(period).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	updateInquiryTimeWindow(id, period) {
		const inquiry = Inquiries$1.build(this.activity.inquiry).updateTimeWindow(id, period).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	removeInquiryTimeWindow(id) {
		const inquiry = Inquiries$1.build(this.activity.inquiry).removeTimeWindow(id).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	addInquiry(form) {
		const inquiry = Inquiries$1.build(this.activity.inquiry).addRequest(form).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	updateInquiry(form) {
		const inquiry = Inquiries$1.build(this.activity.inquiry).updateRequest(form).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	removeInquiry(form) {
		const inquiry = Inquiries$1.build(this.activity.inquiry).removeRequest(form.slug).inquiry;
		return {
			...this.activity,
			inquiry
		};
	}
	assignInquiryToDrive() {
		throw new AssignDriveInDraft("FA");
	}
};
//#endregion
//#region src/festival-activity/preparation/prepare-festival-activity.ts
var PrepareFestivalActivity = class {
	festivalActivities;
	constructor(festivalActivities) {
		this.festivalActivities = festivalActivities;
	}
	findAll() {
		return this.festivalActivities.findAll();
	}
	findById(id) {
		return this.festivalActivities.findById(id);
	}
	getPrepareHelper(existingFA) {
		return isDraft(existingFA) ? PrepareDraftFestivalActivity.build(existingFA) : PrepareInReviewFestivalActivity.build(existingFA);
	}
	async updateGeneralSection(id, general) {
		const existingFA = await this.findActivityIfExists(id);
		const updatedFA = this.getPrepareHelper(existingFA).updateGeneral(general);
		return this.festivalActivities.save(updatedFA);
	}
	async addTimeWindowInGeneral(faId, period) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).addGeneralTimeWindow(period);
		return this.festivalActivities.save(updatedFA);
	}
	async updateTimeWindowInGeneral(faId, timeWindowId, period) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).updateGeneralTimeWindow(timeWindowId, period);
		return this.festivalActivities.save(updatedFA);
	}
	async removeTimeWindowFromGeneral(faId, timeWindowId) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).removeGeneralTimeWindow(timeWindowId);
		return this.festivalActivities.save(updatedFA);
	}
	async updateInChargeSection(id, inCharge) {
		const existingFA = await this.findActivityIfExists(id);
		const updatedFA = this.getPrepareHelper(existingFA).updateInCharge(inCharge);
		return this.festivalActivities.save(updatedFA);
	}
	async addContractor(faId, contractor) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).addContractor(contractor);
		return this.festivalActivities.save(updatedFA);
	}
	async updateContractor(faId, contractor) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).updateContractor(contractor);
		return this.festivalActivities.save(updatedFA);
	}
	async removeContractor(faId, contractorId) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).removeContractor(contractorId);
		return this.festivalActivities.save(updatedFA);
	}
	async updateSignaSection(id, signa) {
		const existingFA = await this.findActivityIfExists(id);
		const updatedFA = this.getPrepareHelper(existingFA).updateSigna(signa);
		return this.festivalActivities.save(updatedFA);
	}
	async addSignage(faId, signage) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).addSignage(signage);
		return this.festivalActivities.save(updatedFA);
	}
	async updateSignage(faId, signage) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).updateSignage(signage);
		return this.festivalActivities.save(updatedFA);
	}
	async removeSignage(faId, signageId) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).removeSignage(signageId);
		return this.festivalActivities.save(updatedFA);
	}
	async updateSecuritySection(id, security) {
		const existingFA = await this.findActivityIfExists(id);
		const updatedFA = this.getPrepareHelper(existingFA).updateSecurity(security);
		return this.festivalActivities.save(updatedFA);
	}
	async updateSupplySection(id, supply) {
		const existingFA = await this.findActivityIfExists(id);
		const updatedFA = this.getPrepareHelper(existingFA).updateSupply(supply);
		return this.festivalActivities.save(updatedFA);
	}
	async addElectricitySupply(faId, electricitySupply) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).addElectricitySupply(electricitySupply);
		return this.festivalActivities.save(updatedFA);
	}
	async updateElectricitySupply(faId, electricitySupply) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).updateElectricitySupply(electricitySupply);
		return this.festivalActivities.save(updatedFA);
	}
	async removeElectricitySupply(faId, electricitySupplyId) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).removeElectricitySupply(electricitySupplyId);
		return this.festivalActivities.save(updatedFA);
	}
	async initInquiry(faId, inquiryInitializer) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).initInquiry(inquiryInitializer);
		return this.festivalActivities.save(updatedFA);
	}
	async clearInquiry(faId) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).clearInquiry();
		return this.festivalActivities.save(updatedFA);
	}
	async addTimeWindowInInquiry(faId, period) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).addInquiryTimeWindow(period);
		return this.festivalActivities.save(updatedFA);
	}
	async updateTimeWindowInInquiry(faId, timeWindowId, period) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).updateInquiryTimeWindow(timeWindowId, period);
		return this.festivalActivities.save(updatedFA);
	}
	async removeTimeWindowFromInquiry(faId, timeWindowId) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).removeInquiryTimeWindow(timeWindowId);
		return this.festivalActivities.save(updatedFA);
	}
	async addInquiryRequest(faId, inquiry) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).addInquiry(inquiry);
		return this.festivalActivities.save(updatedFA);
	}
	async updateInquiryRequest(faId, inquiry) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).updateInquiry(inquiry);
		return this.festivalActivities.save(updatedFA);
	}
	async removeInquiryRequest(faId, inquiry) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).removeInquiry(inquiry);
		return this.festivalActivities.save(updatedFA);
	}
	async findActivityIfExists(id) {
		const existingFA = await this.festivalActivities.findById(id);
		if (!existingFA) throw new FestivalActivityNotFound(id);
		return existingFA;
	}
	async assignInquiryToDrive(faId, link) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).assignInquiryToDrive(link);
		return this.festivalActivities.save(updatedFA);
	}
	async linkSignageToCatalogItem(faId, link) {
		const existingFA = await this.findActivityIfExists(faId);
		const updatedFA = this.getPrepareHelper(existingFA).linkSignageToCatalogItem(link);
		return this.festivalActivities.save(updatedFA);
	}
	async publishFeedback(faId, { author, content }) {
		const existingFA = await this.findActivityIfExists(faId);
		const feedback = {
			author,
			content,
			publishedAt: /* @__PURE__ */ new Date()
		};
		const feedbacks = [...existingFA.feedbacks, feedback];
		const updatedFA = {
			...existingFA,
			feedbacks
		};
		return this.festivalActivities.save(updatedFA);
	}
};
//#endregion
//#region src/festival-activity/ask-for-review/festival-activities.inmemory.ts
var InMemoryAskForReviewFestivalActivityRepository = class {
	festivalActivities;
	constructor(festivalActivities) {
		this.festivalActivities = festivalActivities;
	}
	findById(id) {
		const festivalActivity = this.festivalActivities.find((festivalActivity) => festivalActivity.id === id);
		return Promise.resolve(festivalActivity ?? null);
	}
	save(festivalActivity) {
		const festivalActivityIndex = this.festivalActivities.findIndex((festivalActivityToUpdate) => festivalActivityToUpdate.id === festivalActivity.id);
		if (festivalActivityIndex === -1) throw new FestivalActivityNotFound(festivalActivity.id);
		this.festivalActivities = updateItemToList(this.festivalActivities, festivalActivityIndex, festivalActivity);
		return Promise.resolve(festivalActivity);
	}
};
//#endregion
//#region src/festival-activity/ask-for-review/specifications/general-section-specification.ts
const REQUIRED_DESCRIPTION = "Une description est nécessaire";
const REQUIRED_PHOTO_ON_PUBLIC_ACTIVITY = "Une photo est nécessaire pour les animations publiées";
const REQUIRED_CATEGORIES_ON_PUBLIC_ACTIVITY = "Au moins une catégorie est nécessaire pour les animations publiées";
const REQUIRED_TIMEWINDOWS_ON_PUBLIC_ACTIVITY = "Au moins un créneau horaire est nécessaire pour les animations publiées";
var ActivityGeneralSpecification = class {
	static errors(section) {
		return this.hasDescriptionSet(section) ? [] : [REQUIRED_DESCRIPTION];
	}
	static hasDescriptionSet(section) {
		return section.description !== null;
	}
};
var PublicActivityGeneralSpecification = class {
	static errors(section) {
		return [
			...ActivityGeneralSpecification.errors(section),
			...this.photoLinkError(section),
			...this.categoriesError(section),
			...this.timeWindowsError(section)
		];
	}
	static timeWindowsError(section) {
		if (this.hasAtLeastOneTimeWindow(section)) return [];
		return [REQUIRED_TIMEWINDOWS_ON_PUBLIC_ACTIVITY];
	}
	static categoriesError(section) {
		if (this.hasAtLeastOneCategory(section)) return [];
		return [REQUIRED_CATEGORIES_ON_PUBLIC_ACTIVITY];
	}
	static photoLinkError(section) {
		if (this.hasPhotoLinkSet(section)) return [];
		return [REQUIRED_PHOTO_ON_PUBLIC_ACTIVITY];
	}
	static hasAtLeastOneTimeWindow(section) {
		return section.timeWindows.length > 0;
	}
	static hasAtLeastOneCategory(section) {
		return section.categories.length > 0;
	}
	static hasPhotoLinkSet(section) {
		return section.photoLink !== null;
	}
};
//#endregion
//#region src/festival-activity/ask-for-review/specifications/in-charge-section-specification.ts
const REQUIRED_TEAM = "Une équipe responsable est nécessaire";
var ActivityInChargeSpecification = class {
	static errors(section) {
		return this.hasTeamSet(section) ? [] : [REQUIRED_TEAM];
	}
	static hasTeamSet(section) {
		return section.team !== null;
	}
};
//#endregion
//#region src/festival-activity/ask-for-review/specifications/signa-section-specification.ts
const REQUIRED_LOCATION = "Le lieu est nécessaire";
var ActivitySignaSpecification = class {
	static errors(section) {
		if (this.hasLocationSet(section)) return [];
		return [REQUIRED_LOCATION];
	}
	static hasLocationSet(section) {
		return section.location !== null;
	}
};
//#endregion
//#region src/festival-activity/ask-for-review/specifications/inquiry-section-specification.ts
const REQUIRED_INQUIRY_WITH_TIMEWINDOWS = "Au moins une demande de matos est nécessaire pour un créneau matos";
const REQUIRED_TIMEWINDOWS_WITH_INQUIRY = "Au moins un créneau matos est nécessaire pour une demande matos";
function isWithTimeWindows(section) {
	return section.timeWindows.length > 0;
}
function isWithRequest(section) {
	const { barriers, electricity, gears } = section;
	return barriers.length + electricity.length + gears.length > 0;
}
var ActivityInquiryWithTimeWindowsSpecification = class {
	static errors(section) {
		if (isWithRequest(section)) return [];
		return [REQUIRED_INQUIRY_WITH_TIMEWINDOWS];
	}
};
var ActivityInquiryWithRequestSpecification = class {
	static errors(section) {
		if (isWithTimeWindows(section)) return [];
		return [REQUIRED_TIMEWINDOWS_WITH_INQUIRY];
	}
};
var ActivityInquirySpecification = class {
	static errors(section) {
		if (isWithTimeWindows(section)) return ActivityInquiryWithTimeWindowsSpecification.errors(section);
		if (isWithRequest(section)) return ActivityInquiryWithRequestSpecification.errors(section);
		return [];
	}
};
//#endregion
//#region src/common/ready-for-review.error.ts
const CANT_MOVE_TO_IN_REVIEW_ERROR_MESSAGE = "n'a pas pu être passée en relecture";
var ReadyForReviewError = class extends FestivalEventError {
	constructor(errors, identifier = "FA") {
		const message = `${`La ${identifier} ${CANT_MOVE_TO_IN_REVIEW_ERROR_MESSAGE}`}\n${errors.map((error) => `- ${error}`).join("\n")}`;
		super(message);
	}
};
//#endregion
//#region src/festival-activity/ask-for-review/in-review-festival-activity.ts
const PRIVATE_ACTIVITY_REVIEWS = {
	communication: NOT_ASKING_TO_REVIEW,
	humain: REVIEWING,
	signa: REVIEWING,
	secu: REVIEWING,
	matos: REVIEWING,
	elec: REVIEWING,
	barrieres: REVIEWING
};
const PUBLIC_ACTIVITY_REVIEWS = {
	communication: REVIEWING,
	humain: REVIEWING,
	signa: REVIEWING,
	secu: REVIEWING,
	matos: REVIEWING,
	elec: REVIEWING,
	barrieres: REVIEWING
};
var ReviewableSpecification = class {
	static isSatisfiedBy(festivalActivity) {
		return this.errors(festivalActivity).length === 0;
	}
	static generateError(festivalActivity) {
		return new ReadyForReviewError(this.errors(festivalActivity));
	}
	static errors(festivalActivity) {
		const general = isPublicActivity(festivalActivity.general) ? PublicActivityGeneralSpecification.errors(festivalActivity.general) : ActivityGeneralSpecification.errors(festivalActivity.general);
		const inCharge = ActivityInChargeSpecification.errors(festivalActivity.inCharge);
		const signa = ActivitySignaSpecification.errors(festivalActivity.signa);
		const inquiry = ActivityInquirySpecification.errors(festivalActivity.inquiry);
		return [
			...general,
			...inCharge,
			...signa,
			...inquiry
		];
	}
};
var InReviewFestivalActivity = class InReviewFestivalActivity {
	id;
	general;
	inCharge;
	signa;
	security;
	supply;
	inquiry;
	reviews;
	feedbacks;
	history;
	tasks;
	previousReviews;
	constructor(id, general, inCharge, signa, security, supply, inquiry, reviews, feedbacks, history, tasks, previousReviews) {
		this.id = id;
		this.general = general;
		this.inCharge = inCharge;
		this.signa = signa;
		this.security = security;
		this.supply = supply;
		this.inquiry = inquiry;
		this.reviews = reviews;
		this.feedbacks = feedbacks;
		this.history = history;
		this.tasks = tasks;
		this.previousReviews = previousReviews;
	}
	get status() {
		return IN_REVIEW;
	}
	static init(activity, instigator) {
		if (!ReviewableSpecification.isSatisfiedBy(activity)) throw ReviewableSpecification.generateError(activity);
		const reviews = activity.general.toPublish ? PUBLIC_ACTIVITY_REVIEWS : PRIVATE_ACTIVITY_REVIEWS;
		const history = [...activity.history, FestivalActivityKeyEvents.readyToReview(instigator)];
		return new InReviewFestivalActivity(activity.id, activity.general, activity.inCharge, activity.signa, activity.security, activity.supply, activity.inquiry, reviews, activity.feedbacks, history, activity.tasks);
	}
	static build(activity, instigator) {
		const reviews = this.swapRefusedToReviewing(activity.reviews);
		const history = [...activity.history, FestivalActivityKeyEvents.readyToReview(instigator)];
		return new InReviewFestivalActivity(activity.id, activity.general, activity.inCharge, activity.signa, activity.security, activity.supply, activity.inquiry, reviews, activity.feedbacks, history, activity.tasks, activity.reviews);
	}
	static swapRefusedToReviewing(reviews) {
		return {
			communication: reviews.communication !== REJECTED ? reviews.communication : REVIEWING,
			humain: reviews.humain !== REJECTED ? reviews.humain : REVIEWING,
			signa: reviews.signa !== REJECTED ? reviews.signa : REVIEWING,
			secu: reviews.secu !== REJECTED ? reviews.secu : REVIEWING,
			matos: reviews.matos !== REJECTED ? reviews.matos : REVIEWING,
			elec: reviews.elec !== REJECTED ? reviews.elec : REVIEWING,
			barrieres: reviews.barrieres !== REJECTED ? reviews.barrieres : REVIEWING
		};
	}
};
function isPublicActivity(general) {
	return general.toPublish;
}
//#endregion
//#region src/festival-activity/ask-for-review/ask-for-review.ts
var AskForReview = class {
	festivalActivities;
	constructor(festivalActivities) {
		this.festivalActivities = festivalActivities;
	}
	async from(activityId, instigator) {
		const festivalActivity = await this.festivalActivities.findById(activityId);
		if (!festivalActivity) throw new FestivalActivityNotFound(activityId);
		if (isDraft(festivalActivity)) return this.fromDraft(festivalActivity, instigator);
		if (isRefused(festivalActivity)) return this.fromRefused(festivalActivity, instigator);
		throw new CantAskForReview(activityId);
	}
	async fromDraft(activity, instigator) {
		const inReview = InReviewFestivalActivity.init(activity, instigator);
		return this.festivalActivities.save(inReview);
	}
	async fromRefused(activity, instigator) {
		const inReview = InReviewFestivalActivity.build(activity, instigator);
		return this.festivalActivities.save(inReview);
	}
};
function isReviewer(team) {
	return [
		BARRIERES,
		COMMUNICATION,
		LOG_ELEC,
		HUMAIN,
		LOG_MATOS,
		SECU,
		SIGNA
	].includes(team);
}
//#endregion
//#region src/festival-activity/reviewing/reviewing.error.ts
var InDraft = class extends FestivalActivityError {
	constructor(festivalActivityId) {
		const message = `La FA #${festivalActivityId} est encore en brouillon`;
		super(message);
	}
};
var AlreadyRejected = class extends FestivalActivityError {
	constructor(festivalActivityId, team) {
		const message = `La FA #${festivalActivityId} est refusée par l'équipe ${getNameFromReviewer(team)}`;
		super(message);
	}
};
var ShouldLinkCatalogItem = class extends FestivalActivityError {
	constructor() {
		super("Il faut attribuer des références du catalogue aux demandes de signalétiques avant de valider la FA");
	}
};
//#endregion
//#region src/festival-activity/reviewing/reviewing.ts
var Reviewing = class {
	festivalActivities;
	constructor(festivalActivities) {
		this.festivalActivities = festivalActivities;
	}
	async approve(faId, team, approver) {
		const festivalActivity = await this.festivalActivities.findById(faId);
		if (!festivalActivity) throw new FestivalActivityNotFound(faId);
		if (isDraft(festivalActivity)) throw new InDraft(faId);
		if (this.isAlreadyApprovedBy(festivalActivity, team)) throw new AlreadyApproved(faId, team, "FA");
		if (this.isNotAskingToReview(festivalActivity, team)) throw new NotAskingToReview(faId, team, "FA");
		if (isInquiryOwner(team)) this.checkInquiryDriveAssignment(festivalActivity, team);
		if (team === SIGNA) this.checkSignageCatalogItemLink(festivalActivity);
		const reviews = {
			...festivalActivity.reviews,
			[team]: APPROVED
		};
		const history = [...festivalActivity.history, FestivalActivityKeyEvents.approved(approver, team)];
		return this.saveFestivalActivity(festivalActivity, reviews, history);
	}
	async reject(faId, { team, rejector, reason }) {
		const festivalActivity = await this.festivalActivities.findById(faId);
		if (!festivalActivity) throw new FestivalActivityNotFound(faId);
		if (isDraft(festivalActivity)) throw new InDraft(faId);
		if (this.isNotAskingToReview(festivalActivity, team)) throw new NotAskingToReview(faId, team, "FA");
		if (this.isAlreadyRejectedBy(festivalActivity, team)) throw new AlreadyRejected(faId, team);
		const reviews = {
			...festivalActivity.reviews,
			[team]: REJECTED
		};
		const history = [...festivalActivity.history, FestivalActivityKeyEvents.rejected(rejector, team, reason)];
		return this.festivalActivities.save({
			...festivalActivity,
			status: REFUSED,
			reviews,
			history
		});
	}
	async saveFestivalActivity(storedActivity, reviews, history) {
		if (isValidatedReviews(reviews)) return this.festivalActivities.save({
			...storedActivity,
			status: VALIDATED,
			reviews,
			history
		});
		if (isRefusedReviews(reviews)) return this.festivalActivities.save({
			...storedActivity,
			status: REFUSED,
			reviews,
			history
		});
		return this.festivalActivities.save({
			...storedActivity,
			status: IN_REVIEW,
			reviews,
			history
		});
	}
	checkInquiryDriveAssignment(festivalActivity, owner) {
		if (!selectMyInquiryRequests(owner, festivalActivity)?.every((request) => Object.hasOwn(request, "drive"))) throw new ShouldAssignDrive();
	}
	checkSignageCatalogItemLink(festivalActivity) {
		if (!festivalActivity.signa.signages.every((signage) => isLinkedToCatalogItem(signage))) throw new ShouldLinkCatalogItem();
	}
	isAlreadyApprovedBy(festivalActivity, team) {
		return getTeamReview$1(festivalActivity.reviews, team) === APPROVED;
	}
	isAlreadyRejectedBy(festivalActivity, team) {
		return getTeamReview$1(festivalActivity.reviews, team) === REJECTED;
	}
	isNotAskingToReview(festivalActivity, team) {
		return getTeamReview$1(festivalActivity.reviews, team) === NOT_ASKING_TO_REVIEW;
	}
};
function getTeamReview$1(reviews, team) {
	switch (team) {
		case HUMAIN: return reviews.humain;
		case SIGNA: return reviews.signa;
		case SECU: return reviews.secu;
		case LOG_MATOS: return reviews.matos;
		case LOG_ELEC: return reviews.elec;
		case BARRIERES: return reviews.barrieres;
		case COMMUNICATION: return reviews.communication;
	}
}
function selectMyInquiryRequests(owner, festivalActivity) {
	switch (owner) {
		case LOG_MATOS: return festivalActivity.inquiry.gears;
		case BARRIERES: return festivalActivity.inquiry.barriers;
		case LOG_ELEC: return festivalActivity.inquiry.electricity;
	}
}
function isInquiryOwner(team) {
	return [
		LOG_MATOS,
		LOG_ELEC,
		BARRIERES
	].includes(team);
}
//#endregion
//#region src/festival-task/festival-task.event.ts
var FestivalTaskKeyEvents = class {
	static created(by) {
		const at = this.computeAt();
		return {
			action: CREATED,
			by,
			at,
			description: "FT créée"
		};
	}
	static resetReview(by, reason) {
		const at = this.computeAt();
		const description = `Précédentes approbations réinitialisées par ${reason}`;
		return {
			action: RESET_REVIEW,
			by,
			at,
			description
		};
	}
	static readyToReview(by) {
		const at = this.computeAt();
		return {
			action: READY_TO_REVIEW,
			by,
			at,
			description: "Demande de relecture de la FT"
		};
	}
	static rejected(by, team, reason) {
		const at = this.computeAt();
		const description = `FT rejetée par l'équipe ${getNameFromReviewer(team)} pour la raison suivante: ${reason}`;
		return {
			action: REJECTED,
			by,
			at,
			description
		};
	}
	static approved(by, team) {
		const at = this.computeAt();
		const description = `FT approuvée par l'équipe ${getNameFromReviewer(team)}`;
		return {
			action: APPROVED,
			by,
			at,
			description
		};
	}
	static assignmentStarted(by) {
		const at = this.computeAt();
		return {
			action: ASSIGNMENT_STARTED,
			by,
			at,
			description: "Affectation activée pour la FT"
		};
	}
	static forceInstructions(by) {
		const at = this.computeAt();
		return {
			action: FORCED_UPDATE,
			by,
			at,
			description: "Mise à jour forcée des instructions"
		};
	}
	static computeAt() {
		const at = /* @__PURE__ */ new Date();
		at.setMilliseconds(0);
		return at;
	}
};
//#endregion
//#region src/festival-task/create/create.ts
const FT_420 = 420;
var CreateFestivalTask = class {
	festivalTasks;
	festivalTaskTranslator;
	idGenerator;
	constructor(festivalTasks, festivalTaskTranslator, startId = 1) {
		this.festivalTasks = festivalTasks;
		this.festivalTaskTranslator = festivalTaskTranslator;
		this.idGenerator = numberGenerator(startId, [FT_420]);
	}
	async apply({ name, author, festivalActivity }) {
		const festivalTask = {
			id: this.generateId(),
			status: DRAFT,
			festivalActivity,
			general: {
				name,
				administrator: author,
				team: null
			},
			instructions: {
				appointment: null,
				global: null,
				inCharge: {
					volunteers: [],
					instruction: null
				},
				contacts: []
			},
			history: [FestivalTaskKeyEvents.created(author)],
			feedbacks: [],
			mobilizations: [],
			inquiries: []
		};
		const created = await this.festivalTasks.add(festivalTask);
		const withConflicts = await this.festivalTaskTranslator.translate(created);
		if (!isDraft(withConflicts)) throw new FestivalTaskError("Impossible de créer en BROUILLON");
		return withConflicts;
	}
	generateId() {
		return this.idGenerator.next().value;
	}
};
//#endregion
//#region src/festival-task/ask-for-review/in-review-specification.ts
var InReviewSpecification = class {
	task;
	constructor(task) {
		this.task = task;
	}
	static isSatisfiedBy(task) {
		return GeneralSpecification.isSatisfiedBy(task.general) && MobilizationsSpecification.isSatisfiedBy(task.mobilizations) && InstructionsSpecification.isSatisfiedBy(task.instructions);
	}
	static generateErrors(task) {
		return [
			...GeneralSpecification.generateErrors(task.general),
			...InstructionsSpecification.generateErrors(task.instructions),
			...MobilizationsSpecification.generateErrors(task.mobilizations)
		];
	}
};
var GeneralSpecification = class {
	static isSatisfiedBy(general) {
		return this.hasTeam(general);
	}
	static generateErrors(general) {
		return !this.hasTeam(general) ? [this.teamIsMandatory] : [];
	}
	static hasTeam(general) {
		return general.team !== null;
	}
	static get teamIsMandatory() {
		return "Une équipe responsable est nécessaire";
	}
};
var MobilizationsSpecification = class MobilizationsSpecification {
	static isSatisfiedBy(mobilizations) {
		return this.hasMobilization(mobilizations) && mobilizations.every(MobilizationsSpecification.hasRequest);
	}
	static generateErrors(mobilizations) {
		return [...this.minumumMobilizationError(mobilizations), ...this.requestError(mobilizations)];
	}
	static requestError(mobilizations) {
		return mobilizations.some((mobilization) => !this.hasRequest(mobilization)) ? [this.allMobilizationsHaveRequest] : [];
	}
	static minumumMobilizationError(mobilizations) {
		return !this.hasMobilization(mobilizations) ? [this.atLeastOneMobilizationIsMandatory] : [];
	}
	static hasMobilization(mobilizations) {
		return hasAtLeastOneItem(mobilizations);
	}
	static hasRequest(mobilization) {
		const requestVolunteers = hasAtLeastOneItem(mobilization.volunteers);
		const requestTeamMembers = hasAtLeastOneItem(mobilization.teams);
		return requestVolunteers || requestTeamMembers;
	}
	static get atLeastOneMobilizationIsMandatory() {
		return "Au moins une mobilisation est nécessaire";
	}
	static get allMobilizationsHaveRequest() {
		return "Toutes les mobilisations doivent demander au moins une personne (nominativement ou via les équipes)";
	}
};
var InstructionsSpecification = class {
	static isSatisfiedBy(instructions) {
		return InChargeInstructionsSpecification.isSatisfiedBy(instructions.inCharge) && hasAtLeastOneItem(instructions.contacts) && instructions.appointment !== null && instructions.global !== null;
	}
	static generateErrors(instructions) {
		return [
			...this.appointmentErrors(instructions.appointment),
			...this.globalInstructionErrors(instructions.global),
			...this.contactErrors(instructions.contacts),
			...InChargeInstructionsSpecification.generateErrors(instructions.inCharge)
		];
	}
	static contactErrors(contacts) {
		return !hasAtLeastOneItem(contacts) ? [this.atLeastOneContactIsMandatory] : [];
	}
	static appointmentErrors(appointment) {
		return appointment === null ? [this.appointmentIsMandatory] : [];
	}
	static globalInstructionErrors(global) {
		return global === null ? [this.globalInstructionIsMandatory] : [];
	}
	static get atLeastOneContactIsMandatory() {
		return "Au moins une personne à contacter est nécessaire";
	}
	static get appointmentIsMandatory() {
		return "Un lieu de rendez-vous est nécessaire";
	}
	static get globalInstructionIsMandatory() {
		return "Des instructions sont nécessaires";
	}
};
var InChargeInstructionsSpecification = class {
	static isSatisfiedBy(inCharge) {
		return this.isFilled(inCharge) || this.isEmpty(inCharge);
	}
	static isFilled(inCharge) {
		return hasAtLeastOneItem(inCharge.volunteers) && inCharge.instruction !== null;
	}
	static isEmpty(inCharge) {
		return inCharge.instruction === null && isEmpty(inCharge.volunteers);
	}
	static generateErrors(inCharge) {
		if (this.isFilled(inCharge) || this.isEmpty(inCharge)) return [];
		return inCharge.instruction === null ? [this.instructionIsMandatory] : [this.volunteerIsMandatory];
	}
	static get volunteerIsMandatory() {
		return "Des responsables sont nécessaires pour les instructions spécifiques";
	}
	static get instructionIsMandatory() {
		return "Des instructions spécifiques sont nécessaires pour les responsables";
	}
};
//#endregion
//#region src/festival-task/ask-for-review/ask-for-review.error.ts
var AskForReviewError = class extends ReadyForReviewError {
	constructor(task) {
		super(InReviewSpecification.generateErrors(task), "FT");
	}
};
//#endregion
//#region src/festival-task/ask-for-review/in-review-festival-task.ts
const NO_SUPPLY_REQUEST_TASK_REVIEWS = {
	elec: NOT_ASKING_TO_REVIEW,
	matos: REVIEWING,
	humain: REVIEWING
};
const TASK_WITH_SUPPLY_REQUEST_REVIEWS = {
	elec: REVIEWING,
	matos: REVIEWING,
	humain: REVIEWING
};
var InReviewFestivalTask = class InReviewFestivalTask {
	_task;
	previousReview;
	constructor(_task, previousReview) {
		this._task = _task;
		this.previousReview = previousReview;
	}
	static fromDraft(task, instigator, reviewer) {
		if (!InReviewSpecification.isSatisfiedBy(task)) throw new AskForReviewError(task);
		const inReview = {
			...task,
			history: this.addReadyToReviewEvent(task.history, instigator),
			reviews: this.initReviews(task.festivalActivity),
			reviewer
		};
		return new InReviewFestivalTask(inReview);
	}
	static fromRefused(task, instigator) {
		const history = this.addReadyToReviewEvent(task.history, instigator);
		const reviews = InReviewFestivalTask.resetReviews(task.reviews);
		const inReview = {
			...task,
			history,
			reviews
		};
		return new InReviewFestivalTask(inReview, task.reviews);
	}
	static initReviews({ hasSupplyRequest }) {
		if (hasSupplyRequest) return TASK_WITH_SUPPLY_REQUEST_REVIEWS;
		return NO_SUPPLY_REQUEST_TASK_REVIEWS;
	}
	static resetReviews(reviews) {
		return {
			humain: reviews.humain === REJECTED ? REVIEWING : reviews.humain,
			matos: reviews.matos === REJECTED ? REVIEWING : reviews.matos,
			elec: reviews.elec === REJECTED ? REVIEWING : reviews.elec
		};
	}
	static addReadyToReviewEvent(history, instigator) {
		const readyToReview = FestivalTaskKeyEvents.readyToReview(instigator);
		return [...history, readyToReview];
	}
	get task() {
		return {
			...this._task,
			status: IN_REVIEW
		};
	}
};
//#endregion
//#region src/festival-task/ask-for-review/ask-for-review.ts
var AskForReview$1 = class {
	repositories;
	translator;
	constructor(repositories, translator) {
		this.repositories = repositories;
		this.translator = translator;
	}
	async from(taskId, instigator) {
		const task = await this.repositories.tasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (!isDraft(task) && !isRefused(task)) throw new CantAskForReview(taskId);
		const inReview = await this.convertInReview(task, instigator);
		const saved = await this.repositories.tasks.save(inReview.task);
		return this.translator.translate(saved);
	}
	async convertInReview(task, instigator) {
		if (isDraft(task)) {
			const reviewer = await this.findReviewer(task.general.administrator);
			return InReviewFestivalTask.fromDraft(task, instigator, reviewer);
		}
		return InReviewFestivalTask.fromRefused(task, instigator);
	}
	async findReviewer(administrator) {
		const withoutAdministrator = (await this.repositories.reviewers.getAll()).filter(({ adherent }) => adherent.id !== administrator.id);
		const minReviewsCount = Math.min(...withoutAdministrator.map(({ count }) => count));
		const reviewer = withoutAdministrator.find(({ count }) => count === minReviewsCount);
		if (!reviewer) throw new FestivalTaskError("Aucun relecteur humain disponible");
		return reviewer.adherent;
	}
};
function isReviewer$1(team) {
	return [
		HUMAIN,
		LOG_MATOS,
		LOG_ELEC
	].includes(team);
}
//#endregion
//#region src/festival-task/festival-task.ts
function isReadyToAssign(task) {
	return task.status === READY_TO_ASSIGN;
}
//#endregion
//#region src/festival-task/prepare/sections/mobilizations.ts
var SplitablePeriod = class {
	static checkValidity({ start, end, splitDuration }) {
		if (!Period.init({
			start,
			end
		}).duration.canBeDividedBy(splitDuration)) throw new SplitDurationIsNotPeriodDivider(splitDuration);
	}
};
var Mobilizations = class Mobilizations {
	mobilizations;
	constructor(mobilizations) {
		this.mobilizations = mobilizations;
	}
	static build(mobilizations) {
		return new Mobilizations(mobilizations);
	}
	add(form) {
		const mobilization = MobilizationFactory.init(form).json;
		if (this.has(mobilization)) throw new MobilizationAlreadyExist();
		return new Mobilizations([...this.mobilizations, mobilization]);
	}
	remove(mobilizationId) {
		return new Mobilizations(this.mobilizations.filter(({ id }) => id !== mobilizationId));
	}
	update(mobilizationId, update) {
		const { index, value } = this.retrieveMobilization(mobilizationId);
		if (index === -1 || !value) throw new MobilizationNotFound();
		const mobilization = MobilizationFactory.build(value).update(update).json;
		if (mobilizationId !== mobilization.id && this.has(mobilization)) throw new MobilizationAlreadyExist();
		const mobilizations = updateItemToList(this.mobilizations, index, mobilization);
		return new Mobilizations(mobilizations);
	}
	addTeamTo(mobilizationId, team) {
		const { index, value } = this.retrieveMobilization(mobilizationId);
		if (index === -1 || !value) return this;
		const builder = MobilizationFactory.build(value);
		const mobilizations = updateItemToList(this.mobilizations, index, builder.addTeam(team).json);
		return new Mobilizations(mobilizations);
	}
	removeTeamFrom(mobilizationId, team) {
		const { index, value } = this.retrieveMobilization(mobilizationId);
		if (index === -1 || !value) return this;
		const builder = MobilizationFactory.build(value);
		const mobilizations = updateItemToList(this.mobilizations, index, builder.removeTeam(team).json);
		return new Mobilizations(mobilizations);
	}
	addVolunteerTo(mobilizationId, volunteer) {
		const { index, value } = this.retrieveMobilization(mobilizationId);
		if (index === -1 || !value) return this;
		const builder = MobilizationFactory.build(value);
		const mobilizations = updateItemToList(this.mobilizations, index, builder.addVolunteer(volunteer).json);
		return new Mobilizations(mobilizations);
	}
	removeVolunteerFrom(mobilizationId, volunteerId) {
		const { index, value } = this.retrieveMobilization(mobilizationId);
		if (index === -1 || !value) return this;
		const builder = MobilizationFactory.build(value);
		const mobilizations = updateItemToList(this.mobilizations, index, builder.removeVolunteer(volunteerId).json);
		return new Mobilizations(mobilizations);
	}
	retrieveMobilization(id) {
		const index = this.mobilizations.findIndex(({ id: currentId }) => currentId === id);
		return {
			index,
			value: this.mobilizations.at(index)
		};
	}
	has(mobilization) {
		return this.mobilizations.some(({ id }) => id === mobilization.id);
	}
	get json() {
		return [...this.mobilizations];
	}
};
var MobilizationFactory = class MobilizationFactory {
	mobilization;
	constructor(mobilization) {
		this.mobilization = mobilization;
	}
	static init(form) {
		const { durationSplitInHour, teams, volunteers, ...period } = form;
		this.checkPeriod(durationSplitInHour, period);
		const id = this.generateId(period);
		return new MobilizationFactory({
			...form,
			id
		});
	}
	static build(mobilization) {
		return new MobilizationFactory(mobilization);
	}
	static checkPeriod(durationSplitInHour, period) {
		if (!durationSplitInHour) return Period.init(period);
		const splitDuration = Duration.hours(durationSplitInHour);
		return SplitablePeriod.checkValidity({
			...period,
			splitDuration
		});
	}
	static generateId(period) {
		const { start, end } = period;
		return `${Duration.ms(start.getTime()).inMinutes}-${Duration.ms(end.getTime()).inMinutes}`;
	}
	update(update) {
		const form = {
			...this.mobilization,
			...update
		};
		return MobilizationFactory.init(form);
	}
	addTeam(teamToAdd) {
		const existingTeamIndex = this.mobilization.teams.findIndex((request) => request.team === teamToAdd.team);
		const teams = existingTeamIndex !== -1 ? updateItemToList(this.mobilization.teams, existingTeamIndex, teamToAdd) : [...this.mobilization.teams, teamToAdd];
		return new MobilizationFactory({
			...this.mobilization,
			teams
		});
	}
	removeTeam(team) {
		const teams = this.mobilization.teams.filter((t) => t.team !== team);
		return new MobilizationFactory({
			...this.mobilization,
			teams
		});
	}
	addVolunteer(volunteer) {
		if (this.hasVolunteer(volunteer)) return this;
		const volunteers = [...this.mobilization.volunteers, {
			...volunteer,
			conflicts: []
		}];
		return new MobilizationFactory({
			...this.mobilization,
			volunteers
		});
	}
	removeVolunteer(volunteerId) {
		const volunteers = this.mobilization.volunteers.filter(({ id }) => id !== volunteerId);
		return new MobilizationFactory({
			...this.mobilization,
			volunteers
		});
	}
	hasVolunteer(volunteer) {
		return this.mobilization.volunteers.some(({ id }) => id === volunteer.id);
	}
	get json() {
		return this.mobilization;
	}
};
//#endregion
//#region src/festival-task/prepare/sections/inquiries.ts
var Inquiries = class Inquiries {
	inquiries;
	constructor(inquiries) {
		this.inquiries = inquiries;
	}
	static build(inquiries) {
		return new Inquiries(inquiries);
	}
	add(inquiry) {
		if (this.has(inquiry)) throw new InquiryAlreadyExists(inquiry.name);
		return new Inquiries([...this.inquiries, inquiry]);
	}
	update(inquiry) {
		const inquiryIndex = this.inquiries.findIndex(({ slug }) => slug === inquiry.slug);
		if (inquiryIndex === -1) throw new InquiryNotFound(inquiry.name);
		const inquiries = updateItemToList(this.inquiries, inquiryIndex, inquiry);
		return new Inquiries(inquiries);
	}
	remove(slug) {
		const inquiries = this.inquiries.filter((inquiry) => inquiry.slug !== slug);
		return new Inquiries(inquiries);
	}
	assignToDrive(link) {
		const inquiries = this.inquiries.map((inquiry) => inquiry.slug === link.slug ? {
			...inquiry,
			drive: link.drive
		} : inquiry);
		return new Inquiries(inquiries);
	}
	has(inquiry) {
		return this.inquiries.some(({ slug }) => slug === inquiry.slug);
	}
	get json() {
		return [...this.inquiries];
	}
};
//#endregion
//#region src/festival-task/sections/instructions.ts
function hasInChargeInstructions(inCharge) {
	return inCharge.volunteers.length > 0;
}
//#endregion
//#region src/festival-task/prepare/sections/instructions.ts
function isForcingInChargeUpdate(forceInstructions) {
	return Object.hasOwn(forceInstructions, "inCharge");
}
function isForcingGlobalUpdate(forceInstructions) {
	return Object.hasOwn(forceInstructions, "global");
}
var Instructions = class Instructions {
	instructions;
	constructor(instructions) {
		this.instructions = instructions;
	}
	static build(instructions) {
		return new Instructions(instructions);
	}
	static forceUpdate(currentInstructions, force) {
		const global = isForcingGlobalUpdate(force) ? force.global : currentInstructions.global;
		const currentInCharge = currentInstructions.inCharge;
		const inCharge = isForcingInChargeUpdate(force) && hasInChargeInstructions(currentInCharge) ? {
			...currentInCharge,
			instruction: force.inCharge
		} : currentInCharge;
		return {
			...currentInstructions,
			global,
			inCharge
		};
	}
	update({ inCharge, ...form }) {
		const updatedInCharge = InCharge.build(this.instructions.inCharge).update(inCharge).json;
		const instructions = {
			...this.instructions,
			...form,
			inCharge: updatedInCharge
		};
		return new Instructions(instructions);
	}
	addContact(contact) {
		const contacts = Contacts.build(this.instructions.contacts).add(contact).json;
		return new Instructions({
			...this.instructions,
			contacts
		});
	}
	removeContact(contactId) {
		const contacts = Contacts.build(this.instructions.contacts).remove(contactId).json;
		return new Instructions({
			...this.instructions,
			contacts
		});
	}
	addVolunteer(volunteer) {
		const inCharge = InCharge.build(this.instructions.inCharge).addVolunteer(volunteer).json;
		return new Instructions({
			...this.instructions,
			inCharge
		});
	}
	removeVolunteer(volunteerId) {
		const inCharge = InCharge.build(this.instructions.inCharge).removeVolunteer(volunteerId).json;
		return new Instructions({
			...this.instructions,
			inCharge
		});
	}
	clearInCharge() {
		const inCharge = InCharge.build(this.instructions.inCharge).clear().json;
		return new Instructions({
			...this.instructions,
			inCharge
		});
	}
	initInCharge(volunteers, instruction) {
		const inCharge = InCharge.build({
			volunteers,
			instruction
		}).json;
		return new Instructions({
			...this.instructions,
			inCharge
		});
	}
	get json() {
		return { ...this.instructions };
	}
};
var InCharge = class InCharge {
	inCharge;
	constructor(inCharge) {
		this.inCharge = inCharge;
	}
	static build(inCharge) {
		return new InCharge(inCharge);
	}
	update(instruction) {
		if (instruction === void 0) return this;
		return new InCharge({
			...this.inCharge,
			instruction
		});
	}
	addVolunteer(volunteer) {
		const volunteers = Volunteers.build(this.inCharge.volunteers).add(volunteer).json;
		return new InCharge({
			...this.inCharge,
			volunteers
		});
	}
	removeVolunteer(volunteerId) {
		const volunteers = Volunteers.build(this.inCharge.volunteers).remove(volunteerId).json;
		return new InCharge({
			...this.inCharge,
			volunteers
		});
	}
	clear() {
		const volunteers = Volunteers.build([]).json;
		const instruction = null;
		return new InCharge({
			...this.inCharge,
			volunteers,
			instruction
		});
	}
	get json() {
		return { ...this.inCharge };
	}
};
var Contacts = class Contacts {
	contacts;
	constructor(contacts) {
		this.contacts = contacts;
	}
	static build(contacts) {
		return new Contacts(contacts);
	}
	add(contact) {
		if (this.has(contact)) return this;
		return new Contacts([...this.contacts, contact]);
	}
	remove(contactId) {
		return new Contacts(this.contacts.filter(({ id }) => id !== contactId));
	}
	has(contact) {
		return this.contacts.some(({ id }) => id === contact.id);
	}
	get json() {
		return [...this.contacts];
	}
};
var Volunteers = class Volunteers {
	volunteers;
	constructor(volunteers) {
		this.volunteers = volunteers;
	}
	static build(volunteers) {
		return new Volunteers(volunteers);
	}
	add(volunteer) {
		if (this.has(volunteer)) return this;
		return new Volunteers([...this.volunteers, volunteer]);
	}
	remove(volunteerId) {
		const volunteers = this.volunteers.filter(({ id }) => id !== volunteerId);
		return new Volunteers(volunteers);
	}
	has(volunteer) {
		return this.volunteers.some(({ id }) => id === volunteer.id);
	}
	get json() {
		return [...this.volunteers];
	}
};
//#endregion
//#region src/common/time-window.ts
function readablePeriodFrom({ start, end }) {
	const locales = "fr-FR";
	const options = {
		weekday: "long",
		month: "long",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		timeZone: "Europe/Paris"
	};
	return `du ${start.toLocaleDateString(locales, options)} au ${end.toLocaleDateString(locales, options)}`;
}
function readablePeriodFromId(id) {
	const startTimestamp = parseInt(id.split("-")[0]) * ONE_MINUTE_IN_MS;
	const endTimestamp = parseInt(id.split("-")[1]) * ONE_MINUTE_IN_MS;
	const start = OverDate.from(new Date(startTimestamp)).date;
	const end = OverDate.from(new Date(endTimestamp)).date;
	return readablePeriodFrom({
		start,
		end
	});
}
//#endregion
//#region src/festival-task/prepare/prepare.ts
var PrepareFestivalTaskError = class extends FestivalTaskError {
	constructor(errors) {
		super(errors.join("\n"));
	}
};
var PrepareFestivalTask = class {
	festivalTasks;
	festivalTaskTranslator;
	constructor(festivalTasks, festivalTaskTranslator) {
		this.festivalTasks = festivalTasks;
		this.festivalTaskTranslator = festivalTaskTranslator;
	}
	async updateGeneralSection(taskId, update) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const general = {
			...task.general,
			...update
		};
		const updatedTask = checkValidity({
			...task,
			general
		});
		return this.save(updatedTask);
	}
	async updateInstructionsSection(taskId, update, instigator) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (!this.canUpdateInstructions(task, update)) throw new AlreadyApprovedBy(extractApprovers(task), "FT");
		const instructions = Instructions.build(task.instructions).update(update).json;
		const validTask = checkValidity({
			...task,
			instructions
		});
		const field = update.global ? "instructions" : "instructions des responsables";
		const updatedTask = this.resetApproversReviewOnRefusedTask(validTask, instigator, `un changement sur le champ ${field}`);
		return this.save(updatedTask);
	}
	async forceInstructions(taskId, force, instigator) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isDraft(task)) throw ForceUpdateError.isDraft(task.id);
		if ((isInReview(task) || isRefused(task)) && this.areNoneOfTheReviewersApproved(task)) throw ForceUpdateError.noApprovals(task.id);
		const instructions = Instructions.forceUpdate(task.instructions, force);
		const history = [...task.history, FestivalTaskKeyEvents.forceInstructions(instigator)];
		return this.save({
			...task,
			instructions,
			history
		});
	}
	canUpdateInstructions(task, update) {
		return update.global !== void 0 || update.inCharge !== void 0 ? this.hasReviewersAllowUpdate(task) : !isApprovedBy(HUMAIN, task);
	}
	async addContact(taskId, contact) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const instructions = Instructions.build(task.instructions).addContact(contact).json;
		const updatedTask = checkValidity({
			...task,
			instructions
		});
		return this.save(updatedTask);
	}
	async removeContact(taskId, contactId) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const instructions = Instructions.build(task.instructions).removeContact(contactId).json;
		const updatedTask = checkValidity({
			...task,
			instructions
		});
		return this.save(updatedTask);
	}
	async addInChargeVolunteer(taskId, volunteer) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const instructions = Instructions.build(task.instructions).addVolunteer(volunteer).json;
		const updatedTask = checkValidity({
			...task,
			instructions
		});
		return this.save(updatedTask);
	}
	async removeInChargeVolunteer(taskId, volunteerId) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const instructions = Instructions.build(task.instructions).removeVolunteer(volunteerId).json;
		const updatedTask = checkValidity({
			...task,
			instructions
		});
		return this.save(updatedTask);
	}
	async clearInCharge(taskId, instigator) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (!this.hasReviewersAllowUpdate(task)) throw new AlreadyApprovedBy(extractApprovers(task), "FT");
		const instructions = Instructions.build(task.instructions).clearInCharge().json;
		const validTask = checkValidity({
			...task,
			instructions
		});
		const updatedTask = this.resetApproversReviewOnRefusedTask(validTask, instigator, "la suppression des instructions des responsables");
		return this.save(updatedTask);
	}
	async initInCharge(taskId, { volunteers, instruction }, instigator) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (!this.hasReviewersAllowUpdate(task)) throw new AlreadyApprovedBy(extractApprovers(task), "FT");
		const instructions = Instructions.build(task.instructions).initInCharge(volunteers, instruction).json;
		const validTask = checkValidity({
			...task,
			instructions
		});
		const updatedTask = this.resetApproversReviewOnRefusedTask(validTask, instigator, "l'initialisation des instructions des responsables");
		return this.save(updatedTask);
	}
	async addMobilization(taskId, mobilization, instigator) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (!this.hasReviewersAllowUpdate(task)) throw new AlreadyApprovedBy(extractApprovers(task), "FT");
		const mobilizations = Mobilizations.build(task.mobilizations).add(mobilization).json;
		const validTask = checkValidity({
			...task,
			mobilizations
		});
		const readablePeriod = readablePeriodFrom(mobilization);
		const updatedTask = this.resetApproversReviewOnRefusedTask(validTask, instigator, `l'ajout d'une mobilisation ${readablePeriod}`);
		return this.save(updatedTask);
	}
	async removeMobilization(taskId, mobilizationId, instigator) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (!this.hasReviewersAllowUpdate(task)) throw new AlreadyApprovedBy(extractApprovers(task), "FT");
		const mobilizations = Mobilizations.build(task.mobilizations).remove(mobilizationId).json;
		const validTask = checkValidity({
			...task,
			mobilizations
		});
		const readablePeriod = readablePeriodFromId(mobilizationId);
		const updatedTask = this.resetApproversReviewOnRefusedTask(validTask, instigator, `la suppression de la mobilisation ${readablePeriod}`);
		return this.save(updatedTask);
	}
	async updateMobilization(taskId, mobilizationId, update, instigator) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (!this.hasReviewersAllowUpdate(task)) throw new AlreadyApprovedBy(extractApprovers(task), "FT");
		const mobilizations = Mobilizations.build(task.mobilizations).update(mobilizationId, update).json;
		const validTask = checkValidity({
			...task,
			mobilizations
		});
		const readablePeriod = readablePeriodFromId(mobilizationId);
		const updatedTask = this.resetApproversReviewOnRefusedTask(validTask, instigator, `un changement sur la mobilisation ${readablePeriod}`);
		return this.save(updatedTask);
	}
	async addTeamToMobilization(taskId, mobilizationId, team) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const mobilizations = Mobilizations.build(task.mobilizations).addTeamTo(mobilizationId, team).json;
		const updatedTask = checkValidity({
			...task,
			mobilizations
		});
		return this.save(updatedTask);
	}
	async removeTeamFromMobilization(taskId, mobilizationId, team) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const mobilizations = Mobilizations.build(task.mobilizations).removeTeamFrom(mobilizationId, team).json;
		const updatedTask = checkValidity({
			...task,
			mobilizations
		});
		return this.save(updatedTask);
	}
	async addVolunteerToMobilization(taskId, mobilizationId, volunteer) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const mobilizations = Mobilizations.build(task.mobilizations).addVolunteerTo(mobilizationId, volunteer).json;
		const updatedTask = checkValidity({
			...task,
			mobilizations
		});
		return this.save(updatedTask);
	}
	async removeVolunteerFromMobilization(taskId, mobilizationId, volunteerId) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(HUMAIN, task)) throw new AlreadyApprovedBy([HUMAIN], "FT");
		const mobilizations = Mobilizations.build(task.mobilizations).removeVolunteerFrom(mobilizationId, volunteerId).json;
		const updatedTask = checkValidity({
			...task,
			mobilizations
		});
		return this.save(updatedTask);
	}
	async addInquiry(taskId, inquiry) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isValidated(task) || isReadyToAssign(task)) throw new FestivalTaskError("Cas non géré");
		if (isApprovedBy(LOG_MATOS, task)) throw new AlreadyApprovedBy([LOG_MATOS], "FT");
		const inquiries = Inquiries.build(task.inquiries).add(inquiry).json;
		const validTask = checkValidity({
			...task,
			inquiries
		});
		if (isDraft(validTask)) return this.save(validTask);
		const updatedTask = this.restoreMatosReviewStatus(validTask);
		return this.save(updatedTask);
	}
	restoreMatosReviewStatus(task) {
		if (isDraft(task) || task.reviews.matos !== WILL_NOT_REVIEW) return task;
		const reviews = {
			...task.reviews,
			matos: REVIEWING
		};
		return {
			...task,
			reviews
		};
	}
	async updateInquiry(taskId, inquiry) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isApprovedBy(LOG_MATOS, task)) throw new AlreadyApprovedBy([LOG_MATOS], "FT");
		const inquiries = Inquiries.build(task.inquiries).update(inquiry).json;
		return this.save({
			...task,
			inquiries
		});
	}
	async removeInquiry(taskId, slug) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isApprovedBy(LOG_MATOS, task)) throw new AlreadyApprovedBy([LOG_MATOS], "FT");
		const inquiries = Inquiries.build(task.inquiries).remove(slug).json;
		return this.save({
			...task,
			inquiries
		});
	}
	async assignInquiryToDrive(taskId, link) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (isDraft(task)) throw new AssignDriveInDraft("FT");
		const inquiries = Inquiries.build(task.inquiries).assignToDrive(link).json;
		return this.save({
			...task,
			inquiries
		});
	}
	async publishFeedback(taskId, { author, content }) {
		const task = await this.festivalTasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		const feedback = {
			author,
			content,
			publishedAt: /* @__PURE__ */ new Date()
		};
		const feedbacks = [...task.feedbacks, feedback];
		return this.save({
			...task,
			feedbacks
		});
	}
	async save(toSave) {
		const updated = await this.festivalTasks.save(toSave);
		return this.festivalTaskTranslator.translate(updated);
	}
	hasReviewersAllowUpdate(task) {
		if (isDraft(task) || isRefused(task)) return true;
		if (isValidated(task) || isReadyToAssign(task)) return false;
		return this.areNoneOfTheReviewersApproved(task);
	}
	areNoneOfTheReviewersApproved(task) {
		return !isApprovedBy(HUMAIN, task) && !isApprovedBy(LOG_MATOS, task) && !isApprovedBy(LOG_ELEC, task);
	}
	resetApproversReviewOnRefusedTask(task, instigator, reason) {
		if (!isRefused(task)) return task;
		if (this.areNoneOfTheReviewersApproved(task)) return task;
		const humain = this.resetApproval(task.reviews.humain);
		const matos = this.resetApproval(task.reviews.matos);
		const elec = this.resetApproval(task.reviews.elec);
		const history = [...task.history, FestivalTaskKeyEvents.resetReview(instigator, reason)];
		return {
			...task,
			reviews: {
				humain,
				matos,
				elec
			},
			history
		};
	}
	resetApproval(previous) {
		return previous === APPROVED ? REVIEWING : previous;
	}
};
function isApprovedBy(reviewer, task) {
	if (isDraft(task)) return false;
	switch (reviewer) {
		case HUMAIN: return task.reviews.humain === APPROVED;
		case LOG_MATOS: return task.reviews.matos === APPROVED;
		case LOG_ELEC: return task.reviews.elec === APPROVED;
	}
}
function extractApprovers(task) {
	return [
		HUMAIN,
		LOG_MATOS,
		LOG_ELEC
	].filter((reviewer) => isApprovedBy(reviewer, task));
}
function checkValidity(task) {
	switch (task.status) {
		case DRAFT: return task;
		case IN_REVIEW:
		case REFUSED:
			if (!InReviewSpecification.isSatisfiedBy(task)) throw new PrepareFestivalTaskError(InReviewSpecification.generateErrors(task));
			return task;
		default: throw new FestivalTaskError("Pas encore supporté");
	}
}
//#endregion
//#region src/festival-task/view/view.ts
var ViewFestivalTask = class {
	festivalTasks;
	festivalTaskTranslator;
	constructor(festivalTasks, festivalTaskTranslator) {
		this.festivalTasks = festivalTasks;
		this.festivalTaskTranslator = festivalTaskTranslator;
	}
	all() {
		return this.festivalTasks.all();
	}
	async one(ftId) {
		const task = await this.festivalTasks.one(ftId);
		if (!task) throw new FestivalTaskNotFound(ftId);
		return this.festivalTaskTranslator.translate(task);
	}
	async byAdherentId(adherentId) {
		return this.festivalTasks.byAdherentId(adherentId);
	}
};
//#endregion
//#region src/festival-task/enable-assignment/enable-assignment.ts
var EnableAssignment = class {
	festivalTasks;
	festivalTaskTranslator;
	constructor(festivalTasks, festivalTaskTranslator) {
		this.festivalTasks = festivalTasks;
		this.festivalTaskTranslator = festivalTaskTranslator;
	}
	async for(ftId, instigator, categorize) {
		const task = await this.festivalTasks.findById(ftId);
		if (!task) throw new FestivalTaskNotFound(ftId);
		if (isReadyToAssign(task)) throw new FestivalTaskError("La tâche est déjà en affectation, ce n'est pas normal");
		if (!isValidated(task)) throw new FestivalTaskNotValidated(ftId);
		const readyToAssign = ReadyToAssignFestivalTask.fromValidated(await this.festivalTaskTranslator.translate(task), instigator, categorize);
		const stored = await this.festivalTasks.save(readyToAssign);
		return this.festivalTaskTranslator.translate(stored);
	}
};
var ReadyToAssignFestivalTask = class ReadyToAssignFestivalTask {
	static fromValidated(task, instigator, categorize) {
		if (ReadyToAssignFestivalTask.hasUnavailableVolunteerRequired(task)) throw new ReadyToAssignError();
		const history = [...task.history, FestivalTaskKeyEvents.assignmentStarted(instigator)];
		const mobilizations = task.mobilizations.map((mobilization) => Assignments.generate(mobilization));
		return {
			...task,
			...categorize,
			status: READY_TO_ASSIGN,
			history,
			mobilizations
		};
	}
	static hasUnavailableVolunteerRequired(task) {
		return task.mobilizations.some(({ volunteers }) => volunteers.some(({ conflicts }) => {
			const missingAvailability = conflicts.availability === true;
			const alreadyAssigned = conflicts.assignments.length > 0;
			return missingAvailability || alreadyAssigned;
		}));
	}
};
var Assignments = class Assignments {
	static generate(mobilization) {
		const assignments = Assignments.generatePeriods(mobilization).map((period) => extractAssignment(mobilization, period));
		return {
			...mobilization,
			assignments
		};
	}
	static generatePeriods(mobilization) {
		const mobilizationPeriod = Period.init(mobilization);
		if (mobilization.durationSplitInHour === null) return [mobilizationPeriod];
		return mobilizationPeriod.splitWithInterval(Duration.hours(mobilization.durationSplitInHour));
	}
};
function extractAssignment(mobilization, period) {
	return {
		start: period.start,
		end: period.end,
		id: period.id,
		assignees: mobilization.volunteers.map(extractVolunteerData)
	};
}
function extractVolunteerData(volunteer) {
	return {
		id: volunteer.id,
		lastName: volunteer.lastName,
		firstName: volunteer.firstName,
		nickname: volunteer.nickname
	};
}
//#endregion
//#region src/festival-task/preview-of.ts
function previewOf$1(festivalTask) {
	return PREVIEW_FOR[festivalTask.status](festivalTask);
}
const PREVIEW_FOR = {
	IN_REVIEW: inReviewPreviewOf,
	DRAFT: draftPreviewOf,
	VALIDATED: validatedPreviewOf,
	REFUSED: refusedPreviewOf,
	READY_TO_ASSIGN: readyToAssignPreviewOf
};
function draftPreviewOf(draft) {
	return {
		id: draft.id,
		name: draft.general.name,
		status: draft.status,
		administrator: draft.general.administrator,
		team: draft.general.team
	};
}
function inReviewPreviewOf(inReview) {
	return {
		id: inReview.id,
		name: inReview.general.name,
		status: inReview.status,
		administrator: inReview.general.administrator,
		team: inReview.general.team,
		reviewer: inReview.reviewer,
		reviews: inReview.reviews
	};
}
function validatedPreviewOf(validated) {
	return {
		id: validated.id,
		name: validated.general.name,
		status: validated.status,
		administrator: validated.general.administrator,
		team: validated.general.team,
		reviewer: validated.reviewer,
		reviews: validated.reviews
	};
}
function refusedPreviewOf(refused) {
	return {
		id: refused.id,
		name: refused.general.name,
		status: refused.status,
		administrator: refused.general.administrator,
		team: refused.general.team,
		reviewer: refused.reviewer,
		reviews: refused.reviews
	};
}
function readyToAssignPreviewOf(ready) {
	return {
		id: ready.id,
		name: ready.general.name,
		status: ready.status,
		administrator: ready.general.administrator,
		team: ready.general.team,
		reviewer: ready.reviewer,
		reviews: ready.reviews
	};
}
//#endregion
//#region src/festival-task/sections/mobilizations.ts
const requirableTeams = [
	PERSONNE,
	HARD,
	CONFIANCE,
	VIEUX,
	CONDUCTEUR,
	TECKOS,
	TEAM_MONTAGE,
	TEAM_ELEC,
	TEAM_BOUFFE,
	KARNA,
	BDE,
	KFET
];
const requirableTeamsExtended = [...requirableTeams, SOFT];
//#endregion
//#region src/festival-task/volunteer-conflicts.ts
var FestivalTaskTranslator = class {
	volunteerConflicts;
	constructor(volunteerConflicts) {
		this.volunteerConflicts = volunteerConflicts;
	}
	async translate(task) {
		const mobilizations = await Promise.all(task.mobilizations.map(async (mobilization) => {
			const volunteers = await this.assignConflictsToVolunteers(mobilization, task.id);
			return {
				...mobilization,
				volunteers
			};
		}));
		const translated = {
			...task,
			mobilizations
		};
		if (!isWithConflicts(translated)) throw new FestivalTaskError("Impossible de rajouter les conflits.");
		return translated;
	}
	async assignConflictsToVolunteers(mobilization, taskId) {
		return Promise.all(mobilization.volunteers.map(async (volunteer) => {
			const period = {
				start: mobilization.start,
				end: mobilization.end
			};
			const conflicts = await this.volunteerConflicts.on(taskId, period, volunteer.id);
			return {
				...volunteer,
				conflicts
			};
		}));
	}
};
function isWithConflicts(task) {
	return task.mobilizations.every((mobilization) => mobilization.volunteers.every((volunteer) => Object.hasOwn(volunteer, "conflicts")));
}
//#endregion
//#region src/festival-task/review/review.ts
var Reject = class {
	static from(task, { team, rejector, reason }) {
		const reviews = {
			...task.reviews,
			[team]: REJECTED
		};
		const status = REFUSED;
		const history = [...task.history, FestivalTaskKeyEvents.rejected(rejector, team, reason)];
		return {
			...task,
			reviews,
			status,
			history
		};
	}
};
var Approve = class {
	static from(task, { team, reviewer }) {
		const reviews = {
			...task.reviews,
			[team]: APPROVED
		};
		const history = [...task.history, FestivalTaskKeyEvents.approved(reviewer, team)];
		if (hasAllApproved(reviews)) return {
			...task,
			reviews,
			status: VALIDATED,
			history
		};
		return {
			...task,
			reviews,
			history
		};
	}
};
var Ignore = class {
	static from(task, team) {
		if (!canIgnoreFestivalTaskAs(team)) throw new CannotIgnoreFestivalTask();
		if (task.reviews[`${team}`] === NOT_ASKING_TO_REVIEW) return task;
		if (team === LOG_MATOS && task.inquiries.length > 0) throw new CannotIgnoreFestivalTaskWithInquiryRequests();
		const reviews = {
			...task.reviews,
			[`${team}`]: WILL_NOT_REVIEW
		};
		if (hasAllApproved(reviews)) return {
			...task,
			reviews,
			status: VALIDATED
		};
		if (this.hasNoRejected(reviews)) return {
			...task,
			reviews,
			status: IN_REVIEW
		};
		return {
			...task,
			reviews
		};
	}
	static hasNoRejected(reviews) {
		return Object.values(reviews).every((review) => review !== REJECTED);
	}
};
var DoReview = class {
	static from(task, team) {
		if (task.reviews[`${team}`] !== NOT_ASKING_TO_REVIEW && task.reviews[`${team}`] !== WILL_NOT_REVIEW) return task;
		const reviews = {
			...task.reviews,
			[`${team}`]: REVIEWING
		};
		if (this.hasNoRejected(reviews)) return {
			...task,
			reviews,
			status: IN_REVIEW
		};
		return {
			...task,
			reviews
		};
	}
	static hasNoRejected(reviews) {
		return Object.values(reviews).every((review) => review !== REJECTED);
	}
};
function hasAllApproved(reviews) {
	const validReviews = [
		APPROVED,
		NOT_ASKING_TO_REVIEW,
		WILL_NOT_REVIEW
	];
	return Object.values(reviews).every((review) => validReviews.includes(review));
}
var Review = class {
	tasks;
	translator;
	constructor(tasks, translator) {
		this.tasks = tasks;
		this.translator = translator;
	}
	async reject(taskId, rejection) {
		const task = await this.tasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (task.reviews[rejection.team] === NOT_ASKING_TO_REVIEW) throw new NotAskingToReview(task.id, rejection.team, "FT");
		const rejected = await this.tasks.save(Reject.from(task, rejection));
		return this.translator.translate(rejected);
	}
	async approve(taskId, approval) {
		const task = await this.tasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		if (task.reviews[approval.team] === NOT_ASKING_TO_REVIEW) throw new NotAskingToReview(task.id, approval.team, "FT");
		if (this.isAlreadyApprovedBy(task, approval.team)) throw new AlreadyApproved(task.id, approval.team, "FT");
		if (approval.team === LOG_MATOS) this.checkInquiryDriveAssignment(task);
		const approved = Approve.from(task, approval);
		const saved = await this.tasks.save(approved);
		return this.translator.translate(saved);
	}
	async ignore(taskId, team) {
		const task = await this.tasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		const ignored = Ignore.from(task, team);
		const saved = await this.tasks.save(ignored);
		return this.translator.translate(saved);
	}
	async review(taskId, team) {
		const task = await this.tasks.findById(taskId);
		if (!task) throw new FestivalTaskNotFound(taskId);
		const toReview = DoReview.from(task, team);
		const saved = await this.tasks.save(toReview);
		return this.translator.translate(saved);
	}
	checkInquiryDriveAssignment(task) {
		if (!task.inquiries.every((request) => Object.hasOwn(request, "drive"))) throw new ShouldAssignDrive("FT");
	}
	isAlreadyApprovedBy(festivalActivity, team) {
		return getTeamReview(festivalActivity.reviews, team) === APPROVED;
	}
};
function getTeamReview(reviews, team) {
	switch (team) {
		case HUMAIN: return reviews.humain;
		case LOG_MATOS: return reviews.matos;
		case LOG_ELEC: return reviews.elec;
	}
}
function canIgnoreFestivalTaskAs(team) {
	return [LOG_ELEC, LOG_MATOS].includes(team);
}
//#endregion
//#region src/festival-task/remove/remove.ts
var RemoveFestivalTask = class {
	remove;
	constructor(remove) {
		this.remove = remove;
	}
	async apply(id) {
		const status = await this.remove.findStatus(id);
		if (status === null) return;
		if (status === READY_TO_ASSIGN) throw new RemoveReadyToAssignError(id);
		await this.remove.one(id);
	}
};
//#endregion
export { AFFICHE, AskForReview, AskForReview$1 as AskForReviewTask, BACHE, BACKLINE, BENNE_COLLETTE_BESSON, BENNE_PARKING_K_FET, CAVE_BIKERS, CAVE_E, CLUB_ROCK, CONTENEUR_KARNA, CONTENEUR_PARKING_K_FET, CONTENEUR_SCENE_PULSE, CONTENUR_24H, CREUX_GCU, CREUX_GM, CreateFestivalActivity, CreateFestivalTask, EnableAssignment, FestivalActivityError, FestivalEventError, FestivalTaskError, FestivalTaskTranslator, HALL_DES_HUMANITES, InChargeInstructionsSpecification, InMemoryAskForReviewFestivalActivityRepository, InMemoryCreateFestivalActivityRepository, InReviewSpecification, LIVRE_PAR_BAR, LIVRE_PAR_COM, LIVRE_PAR_LOGISTIQUE, LIVRE_PAR_TEAM_ELEC, LOCAL_24H, MAGASIN, MDE, NON_STOCKE, P17_125A_TETRA, P17_16A_MONO, P17_16A_TETRA, P17_16A_TRI, P17_32A_MONO, P17_32A_TETRA, P17_32A_TRI, P17_63A_MONO, P17_63A_TETRA, P17_63A_TRI, PANNEAU, PARKING_EIFFEL, PC16_Prise_classique, PrepareFestivalActivity, PrepareFestivalTask, QG_ORGA, RemoveFestivalTask, Review as ReviewTask, ReviewableSpecification, Reviewing, SALLE_CRLA, SALLE_CRLB, SALLE_MONTREAL, SALLE_RENE_CHAR, ViewFestivalTask, canIgnoreFestivalTaskAs, defaultDraft, drives, extractApprovers, getNameFromReviewer, isReviewer as isActivityReviewer, isAssignedToDrive, isDraft, isInReview, isLinkedToCatalogItem, isReadyToAssign, isRefused, isRefusedReviews, isReviewer$1 as isTaskReviewer, isValidated, isValidatedReviews, previewOf as previewOfActivity, previewOf$1 as previewOfTask, requirableTeams, requirableTeamsExtended, signageTypes };

//# sourceMappingURL=index.mjs.map